<template>
  <div>
    <div v-show="show_section_factura">
      <DetailAccounts :show_message="show_account_detail" :vat="dialog_vat" @close-message="show_account_detail=false" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'_dialog'"></DetailAccounts>
      <v-row v-if="currentDocument" class="pt-4 px-4">
          <v-col cols="12" :sm="6" class="py-1 pr-2"
                 v-if="currentDocument && (got_feature('feature_document_number_prefix') || showDocNumberStr())">
            <doc-text-field
                kind="text"
                @change="setDirty()"
                v-model="document_doc_number_prefix"
                :label="got_feature('feature_document_number_prefix') ? 'Prefijo núm. documento' : 'Número documento'"
                :readonly="!canChange()"
                stylev2
            />
          </v-col>
          <v-col cols="12" :sm="6" class="py-1 pr-2"
                 v-if="currentDocument && (got_feature('feature_document_number_prefix') || (['accounting_invoice', 'accounting', 'pending_sync', 'done'].includes(currentDocument.state) && got_feature('feature_fill_num_doc_pending_sync')))">
            <doc-text-field
                kind="number"
                @change="setDirty()"
                v-model="document_doc_number"
                label="Núm. documento"
                :readonly="!canChange()"
                stylev2                 
            />
          </v-col>
          <v-col cols="12" :style="{margin:'0', padding:'0'}"
            v-if="currentDocument.metadata && (Object.keys(currentDocument.metadata).includes('num_pedido') || Object.keys(currentDocument.metadata).includes('agreement_num'))">
            <!-- Número de pedido -->
            <v-col cols="12" :sm="6" v-if="currentDocument.metadata && Object.keys(currentDocument.metadata).includes('num_pedido')">
              <doc-text-field
                @change="setDirty()"
                v-model="currentDocument.metadata['num_pedido']"
                label="Número de pedido"
                :error="currentDocument.errorJson && currentDocument.errorJson.length && currentDocument.errorJson.includes('num_pedido')"
                :readonly="!canChange()"
                stylev2                 
              />
            </v-col>
            <!-- Número de acuerdo -->
            <v-col cols="12" :sm="6" v-if="currentDocument.metadata && Object.keys(currentDocument.metadata).includes('agreement_num')">
              <doc-text-field
                @change="setDirty()"
                v-model="currentDocument.metadata['agreement_num']"
                label="Número de acuerdo"
                :error="currentDocument.errorJson && currentDocument.errorJson.length && currentDocument.errorJson.includes('agreement_num')"
                :readonly="!canChange()"
                stylev2                 
              />
            </v-col>
          </v-col>
          <v-col cols="12" :sm="7" class="py-1">
            <metadata-field 
                field-key="inv_number" 
                field-text="Núm. Factura" 
                :class="{'disable-text': currentDocument.forced_move, 'activate-text': !currentDocument.forced_move, 'highlight-important-field': isImportantField() }" 
                :required="true" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'inv_number'" 
                :readonly="!canChange()"
                stylev2 
            />
          </v-col>
          <template v-if="document_kind=='in_invoice'">
              <v-col v-if="document_supplierdb_info && !showGenericThirdFields" cols="12" :sm="3" class="py-1 pr-2 pl-2">
                  <doc-text-field class="disable-text" label="CIF" field-text="CIF" readonly :value="document_supplierdb_info.cif" stylev2 />
              </v-col>
              <v-col cols="12" :sm="3" class="py-1 pr-2" v-else>
                <metadata-field 
                    field-key="vat_supplier" 
                    field-text="CIF" 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'vat_supplier'" 
                    :readonly="!canChange()"
                    stylev2 
                />
              </v-col>
          </template>
          <template v-else>
              <v-col v-if="document_customerdb_info && !showGenericThirdFields" cols="12" :sm="3" class="py-1 pr-2 pl-2">
                  <doc-text-field label="CIF" field-text="CIF" readonly :value="document_customerdb_info.cif" stylev2 />
              </v-col>
              <v-col cols="12" :sm="3" class="py-1 pr-2" v-else>
                <metadata-field 
                    field-key="vat_customer" 
                    field-text="CIF" 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'vat_customer'" 
                    :readonly="!canChange()"
                    stylev2 
                />
              </v-col>
          </template>

          <!-- PROVEEDOR -->
          <v-col cols="12" class="py-1" v-if="showGenericThirdFields">
            <template v-if="document_kind=='in_invoice'">
                <metadata-field 
                    field-key="supplier" 
                    field-text="Nombre" 
                    :required="true" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'supplier'" 
                    :readonly="!canChange()"
                    stylev2 
                />
            </template>
            <template v-else>
                <metadata-field 
                    field-key="customer" 
                    field-text="Nombre" 
                    :required="true" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'customer'" 
                    :readonly="!canChange()"
                    stylev2 
                />
            </template>
            
          </v-col>

          <v-col cols="12" class="pt-1 pb-0">
              
              <v-row no-gutters v-if="permission.can_write && document_kind=='in_invoice'" >
                  <div v-if="document_kind=='in_invoice' && ['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching" style="font-size:14px">
                  Hay varios proveedores que encajan, elija el correcto:
              </div>
              <v-col cols="10"> 
                  <v-tooltip top :disabled="document_supplierdb_info && valid_expens_accounts && valid_expens_account_bien_inversion && !unmatchingThird.error">
                      <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                              <autocomplete-with-api
                                  v-if="['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching"
                                  autocomplete="off"
                                  label="Proveedor"
                                  v-model="document_supplierdb_info"
                                  :url="'get_matching_thirds/?doc_id=' + currentDocument.id"
                                  item-text="extended_name"
                                  item_search_field="selector_text"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_supplierdb_info || (document_supplierdb_info && document_supplierdb_info.credit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  :return_object="true"
                                  stylev2                       
                              >
                              </autocomplete-with-api>
                              <v-autocomplete
                                  v-else-if="['done','done_manually', 'done_with_warning'].includes(currentDocument.state) && !(fixMotxo)"
                                  autocomplete="off"
                                  class="select-invoice-stylev2"
                                  v-model="document_supplierdb_info"
                                  :items="[document_supplierdb_info]"
                                  item-text="extended_name"
                                  @change="on_supplierdb_changed()"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :background-color="!document_supplierdb_info || (document_supplierdb_info && document_supplierdb_info.credit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  return-object
                                  :filter="filterBy"
                                  outlined
                                  dense
                                  append-icon="mdi-chevron-down"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{ data.item.cif }} - {{ data.item.name }}
                                  </template>
                                  <template v-slot:prepend>
                                      <label>Proveedor</label>
                                  </template>
                              </v-autocomplete>
                              <autocomplete-with-api
                                  v-else-if="feature_search_thirds_by_api"
                                  label="Proveedor"
                                  v-model="document_supplierdb_info"
                                  :starting_items="suppliers"
                                  :url="'get_all_suppliers/?companydb_id=' + currentCompany.id"
                                  item_text="extended_name"
                                  item_search_field="selector_text"
                                  :return_object="true"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_supplierdb_info || !valid_expens_accounts || !valid_expens_account_bien_inversion || (document_supplierdb_info && document_supplierdb_info.credit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  stylev2
                              ></autocomplete-with-api>
                              <v-autocomplete
                                  v-else
                                  class="select-invoice-stylev2"
                                  autocomplete="off"
                                  v-model="document_supplierdb_info"
                                  :items="suppliers"
                                  item-text="extended_name"
                                  @change="on_supplierdb_changed()"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :background-color="!document_supplierdb_info || !valid_expens_accounts || !valid_expens_account_bien_inversion || (document_supplierdb_info && document_supplierdb_info.credit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  return-object
                                  :filter="filterBy"
                                  outlined
                                  dense
                                  append-icon="mdi-chevron-down"
                                  :class="{
                                    'disable-text': currentDocument.forced_move, 
                                    'activate-text': !currentDocument.forced_move 
                                  }"      
                              >
                                  <template slot="item" slot-scope="data">
                                      {{data.item.selector_text}}
                                  </template>
                                  <template v-slot:prepend>
                                      <label>Proveedor</label>
                                  </template>
                              </v-autocomplete>
                          </div>
                      </template>
                      <span v-if="!document_supplierdb_info || !valid_expens_accounts || !valid_expens_account_bien_inversion || unmatchingThird.error">
                          <div v-if="!document_supplierdb_info">Proveedor no asignado</div>
                          <div v-else-if="!valid_expens_accounts">Cuenta de gastos no asignada</div>
                          <div v-else-if="!valid_expens_account_bien_inversion">Cuenta de gastos en bienes de inversión no asignada</div>
                          <div v-else-if="unmatchingThird.error"> {{ unmatchingThird.tooltip }} </div>
                      </span>
                  </v-tooltip>
              </v-col>
              <!-- BUTTONS EDIT/ERASE (Proveedor) -->
              <v-col cols="2" v-if="Boolean(permission.can_write) && (!got_feature('feature_not_create_thirds_and_masters') || (got_feature('feature_not_create_thirds_and_masters') && document_supplierdb_info))">
                  <v-row>
                      <v-col cols="4" class="py-0">
                          <v-btn
                              color="primary"
                              outlined
                              @click="show_modal()"
                              max-width="25"
                              min-width="25"
                              class="ml-1 mb-2 btn-invoice-edit"
                          >
                              <AppIcon src="/invoices/ink_highlighter.svg" :size="29" v-if="document_supplierdb_info" />                              
                              <v-icon v-else color="primary">mdi-plus</v-icon>
                          </v-btn>
                      </v-col>
                      <v-col cols="4" class="py-0">
                          <v-btn
                              color="primary"
                              v-if="document_supplierdb_info"
                              outlined
                              max-width="25"
                              min-width="25"
                              @click="document_supplierdb=undefined;document_supplierdb_info=undefined"
                              class=" mb-2 btn-invoice-edit"
                              :disabled="currentDocument.forced_move || !canChange()"
                          >
                              <AppIcon src="/invoices/ink_eraser.svg" :size="29" />                               
                          </v-btn>
                      </v-col>
                  </v-row>
                  
              </v-col>
              </v-row>

              <!-- CLIENTE -->
              <v-row no-gutters v-else-if="permission.can_write && document_kind=='out_invoice'">
                  <div v-if="document_kind=='out_invoice' && ['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching" style="font-size:14px">
                  Hay varios clientes que encajan, elija el correcto:
                  </div>
              <v-col cols="9">
                  <v-tooltip top :disabled="document_customerdb_info && valid_income_accounts && !unmatchingThird.error">
                      <template v-slot:activator="{ on, attrs }">
                          <div v-if="currentDocument && currentDocument.companydb" v-bind="attrs" v-on="on">
                              <autocomplete-with-api
                                  v-if="['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching"
                                  autocomplete="off"
                                  label="Cliente"
                                  v-model="document_customerdb_info"
                                  :url="'get_matching_thirds/?doc_id=' + currentDocument.id"
                                  item-text="extended_name"
                                  item_search_field="selector_text"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_customerdb_info || (document_customerdb_info && document_customerdb_info.debit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  :return_object="true"
                                  stylev2
                              >
                              </autocomplete-with-api>
                              <v-autocomplete
                                  v-else-if="['done','done_manually', 'done_with_warning'].includes(currentDocument.state) && !(fixMotxo)"
                                  class="select-invoice-stylev2"
                                  autocomplete="off"
                                  v-model="document_customerdb_info"
                                  :items="[document_customerdb_info]"
                                  item-text="extended_name"
                                  item-value="id"
                                  @change="on_customerdb_changed()"
                                  :background-color="!document_customerdb_info || (document_customerdb_info && document_customerdb_info.debit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  return-object
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :filter="filterBy"
                                  outlined
                                  dense
                                  append-icon="mdi-chevron-down"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{ data.item.cif }} - {{ data.item.name }}
                                  </template>
                                  <template v-slot:prepend>
                                      <label>Cliente</label>
                                  </template>
                              </v-autocomplete>
                              <autocomplete-with-api
                                  v-else-if="feature_search_thirds_by_api"
                                  label="Cliente"
                                  v-model="document_customerdb_info"
                                  :starting_items="customers"
                                  :url="'get_all_customers/?companydb_id=' + currentCompany.id"
                                  item_text="extended_name"
                                  item_search_field="selector_text"
                                  :return_object="true"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :bck_color="!document_customerdb_info || !valid_income_accounts || (document_customerdb_info && document_customerdb_info.debit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  stylev2
                              ></autocomplete-with-api>
                              <v-autocomplete
                                  v-else
                                  class="select-invoice-stylev2"                                    
                                  autocomplete="off"
                                  v-model="document_customerdb_info"
                                  :items="customers"
                                  item-text="extended_name"
                                  item-value="id"
                                  @change="on_customerdb_changed()"
                                  :background-color="!document_customerdb_info || !valid_income_accounts || (document_customerdb_info && document_customerdb_info.debit_account == '') || unmatchingThird.error ? color.error : color.ok"
                                  return-object
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  :filter="filterBy"
                                  outlined
                                  dense
                                  append-icon="mdi-chevron-down"
                              >
                                  <template slot="item" slot-scope="data">
                                      {{data.item.selector_text}}
                                  </template>
                                  <template v-slot:prepend>
                                      <label>Cliente</label>
                                  </template>
                              </v-autocomplete>
                          </div>
                      </template>
                      <span v-if="!document_customerdb_info || !valid_income_accounts || unmatchingThird.error">
                          <div v-if="!document_customerdb_info">Cliente no asignado</div>
                          <div v-else-if="!valid_income_accounts">Cuenta de ingresos no asignada</div>
                          <div v-else-if="unmatchingThird.error"> {{ unmatchingThird.tooltip }} </div>
                      </span>
                  </v-tooltip>
              </v-col>
              <!-- BUTTONS EDIT/ERASE (Cliente) -->
              <v-col cols="3" v-if="(!got_feature('feature_not_create_thirds_and_masters') || (got_feature('feature_not_create_thirds_and_masters') && document_customerdb_info))">
                  <v-row>
                      <v-col cols="6" class="py-0">
                          <v-btn
                          color="primary"
                          outlined
                          @click="show_modal()"
                          max-width="25"
                          min-width="25"
                          class="ml-1 mb-2 btn-invoice-edit"
                      >
                              <AppIcon src="/invoices/ink_highlighter.svg" :size="29" v-if="document_customerdb_info" />
                              <v-icon v-else>mdi-plus</v-icon>
                          </v-btn>
                  </v-col>
                      <v-col cols="6" class="py-0">
                          <v-btn
                              color="primary"
                              v-if="document_customerdb_info"
                              outlined
                              max-width="25"
                              min-width="25"
                              @click="document_customerdb=undefined;document_customerdb_info=undefined"
                              class=" mb-2 btn-invoice-edit"
                              :disabled="currentDocument.forced_move || !canChange()"
                          >
                              <AppIcon src="/invoices/ink_eraser.svg" :size="29" />
                          </v-btn>
                      </v-col>
                  </v-row>

              </v-col>
              </v-row>

              <vies-validator
                  :key="document_kind == 'in_invoice' ? document_supplierdb_info.cif : document_customerdb_info.cif"
                  v-if="got_feature('feature_vies_validation') && currentDocument.intracomunitario && (document_supplierdb_info || document_supplierdb_info)"
                  :third="document_kind == 'in_invoice' ? document_supplierdb_info : document_customerdb_info"
              />
              <v-row v-if="['error_multiple_matching_thirds'].includes(currentDocument.state) && !declined_matching">
                  <v-col cols="6" class="py-1">
                      <v-btn 
                             class="text-none text-subtitle-1" 
                             color="primary" 
                             max-height="20px" 
                             @click="declined_matching=true">
                          Elegir otro tercero
                      </v-btn>
                  </v-col>
              </v-row>
          </v-col>
          <v-col cols="6" class="py-1" v-if="show_third_concept">
              <metadata-field 
                  field-key="third_concept" 
                  :required="true" 
                  :readonly="readOnlyThirdConcept"
                  :tabs="tabs" 
                  kind="special_acc" 
                  field-text="Concepto" 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'third_concept'"
                  stylev2
              />
          </v-col>
          <v-col cols="6" class="py-1" v-if="show_third_concept"></v-col>
      </v-row>
      <v-row class="px-4">
          <!-- Fecha Factura -->
          <v-col cols="4" class="py-1">
              <!-- <v-tooltip top :disabled="currentDocument.accounting_date_config != 'invoice_date' || invoiceDateInPeriod"> -->
              <v-tooltip top :disabled="!errorInvoiceDate">
                  <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                          <metadata-field 
                              field-key="invoice_date" 
                              :editable-forced-move="true" 
                              field-text="Fecha Factura" 
                              kind="date" 
                              :initial_error="['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && currentDocument.errorJson.includes('invoice_date')" 
                              :metadata_error="errorInvoiceDate" 
                              :required="true" 
                              :key="currentDocument.id.toString()+isWaitingFlow.toString()+documentFetched.toString()+'invoice_date'" 
                              stylev2
                              class="activate-text"
                              :class="{ 'highlight-important-field': isImportantField() }"
                              @input="dateErrors_and_setDirty()"
                          />
                      </div> 
                  </template>
                  <span> {{ invoiceTooltip }} </span>
              </v-tooltip>
          </v-col>

            <v-col
                cols="5"
                class="py-1"
                v-if="
                    currentDocument &&
                    currentDocument.metadata &&
                    currentDocument.metadata.operation_date &&
                    got_feature('feature_invoice_operation_date')
                "
            >
                <doc-text-field
                    :disabled="true"
                    :readonly="true"
                    :value="formatDate(currentDocument.metadata.operation_date)"
                    label="Fecha Operación"
                    stylev2
                />
            </v-col>

          <template v-if="currentDocument && !['done', 'pending_upload','done_manually', 'done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice'].includes(currentDocument.state)">
            <!-- Fecha Contable : Select -->
            <v-col cols="6" class="py-1">
                <!-- <v-tooltip top :disabled="currentDocument.accounting_date_config != 'today' || todayDateInPeriod"> -->
                <v-tooltip top :disabled="!errorAccountingDateSelect">
                <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                    <v-select 
                        @change="dateErrors_and_setDirty()" 
                        :disabled="!canChange()"
                        v-model="currentDocument.accounting_date_config" 
                        class="select-invoice-stylev2 activate-text"
                        item-value="id" 
                        item-text="text" 
                        :items="ACCOUNTING_DATE_OPTIONS"
                        :background-color="errorAccountingDateSelect ? color.error : color.ok"
                        outlined
                        dense
                        append-icon="mdi-chevron-down"
                    >
                    <!-- :background-color="(currentDocument.accounting_date_config=='today' && !todayDateInPeriod)?'#ff9898':'#ffffff'" -->
                        <template v-slot:prepend>
                        <label>Fecha Contable</label>
                        </template>
                    </v-select>
                    </div> 
                </template>
                <span> {{ accountingTooltip }} </span>
                </v-tooltip>
            </v-col>
            <!-- ########## -->
            <!-- Text field Fecha Contable configurated -->
            <v-col cols="4" class="py-1" v-if="currentDocument && !['done','done_manually','done_with_warning','pending_sync','pending_connect', 'pending_upload', 'accounting_aplifisa_fiscal','accounting_invoice'].includes(currentDocument.state)">
                <!-- <v-tooltip top v-if="currentDocument.accounting_date_config == 'configurated'" :disabled="accountingDateInPeriod && !accountingDateBeforeInvoice"> -->
                <v-tooltip top v-if="currentDocument.accounting_date_config == 'configurated'" :disabled="!errorAccountingDate">
                <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                    <doc-text-field  
                        kind="date" 
                        :required="currentDocument.accounting_date_config=='configurated'"
                        @input="dateErrors_and_setDirty()" 
                        :readonly="!canChange()" 
                        :error="errorAccountingDate"
                        v-model="currentDocument.default_accounting_date" label="DD/MM/YYYY"
                        stylev2
                    ></doc-text-field>
                    <!-- :error="!accountingDateInPeriod || accountingDateBeforeInvoice" -->
                    </div> 
                </template>
                <span> {{ accountingTooltip }} </span>
                </v-tooltip>
            </v-col>
            <!-- ########## -->
          </template>
          <v-col cols="5" class="py-1" v-if="currentDocument && ['done','done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice', 'pending_upload'].includes(currentDocument.state)">
            <doc-text-field 
              :disabled="true" 
              :readonly="true" 
              v-model="currentDocument.accounting_date" 
              label="Fecha contabilización"
              stylev2
            >
            </doc-text-field>
          </v-col>
          <v-col cols="6" class="py-1" v-if="currentDocument && ['done_manually'].includes(currentDocument.state)">
            <doc-text-field 
              :disabled="false" 
              :readonly="false" 
              v-model="currentDocument.default_accounting_date" 
              label="Fecha contabilización manual"
              stylev2
            >
            </doc-text-field>
          </v-col>
        </v-row>

        <v-row class="px-4">
          <v-col cols="4" class="py-1 pr-2">
              <metadata-field field-key="due_date" field-text="Fecha Vencimiento" kind="date" :initial_error="['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && currentDocument.errorJson.includes('due_date')" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'due_date'" stylev2 :class="{'disable-text': currentDocument.forced_move, 'activate-text': !currentDocument.forced_move }"/>
          </v-col>
          <template v-if="currentDocument && got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii && !['done','done_manually','done_with_warning','pending_sync','pending_connect', 'pending_upload', 'accounting_aplifisa_fiscal','accounting_invoice'].includes(currentDocument.state)">
            <!-- Fecha Registro : Select -->
            <v-col cols="4" class="py-1"> 
              <!-- <v-tooltip top :disabled="currentDocument.registro_date_config != 'today' || (todayDateInPeriod && !todayRegDateBeforeAccConfig)"> -->
              <v-tooltip top :disabled="!errorRegistroDateSelect">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">   
                  <v-select 
                    @change="dateErrors_and_setDirty()" 
                    :disabled="!canChange()"
                    v-model="currentDocument.registro_date_config" 
                    class="select-invoice-stylev2"
                    item-value="id" 
                    item-text="text" 
                    :items="REGISTRO_DATE_OPTIONS"
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    :background-color="errorRegistroDateSelect ? color.error : color.ok"
                  >
                  <!-- :background-color="(currentDocument.registro_date_config=='today' && (!todayDateInPeriod || todayRegDateBeforeAccConfig)) ? '#ff9898' : '#ffffff'" -->
                    <template v-slot:prepend>
                      <label>Fecha SII</label>
                    </template>      
                  </v-select>
                </div>
              </template>
              <span> {{ registroTooltip }} </span>
              </v-tooltip>
            </v-col>
            <!-- ########## -->
            <!-- Text field Fecha Registro configurated -->
            <v-col cols="4" class="py-1" v-if="currentDocument.registro_date_config=='configurated'">
              <!-- <v-tooltip top v-if="currentDocument.registro_date_config == 'configurated'" :disabled="registroDateInPeriod && !registroDateBeforeAccounting"> -->
              <v-tooltip top v-if="currentDocument.registro_date_config == 'configurated'" :disabled="!errorRegistroDate">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                <doc-text-field  
                  kind="date" 
                  @input="dateErrors_and_setDirty()" 
                  :readonly="!canChange()"
                  :error="errorRegistroDate"
                  v-model="currentDocument.default_registro_date" 
                  label="DD/MM/YYYY"
                  stylev2
                ></doc-text-field>
                <!-- :error="!registroDateInPeriod || registroDateBeforeAccounting" -->
                </div>
              </template>
              <span> {{ registroTooltip }} </span>
              </v-tooltip>
            </v-col>
            <!-- ########## -->
          </template>
        <v-col cols="5" class="py-1" v-if="currentDocument && got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii && ['done','done_manually','done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice', 'pending_upload'].includes(currentDocument.state) && currentDocument.registro_date">
            <doc-text-field 
                :disabled="true" 
                :readonly="true" 
                v-model="currentDocument.registro_date" 
                label="Fecha SII"
                stylev2
            >
            </doc-text-field>
        </v-col>

      </v-row>
      <v-row class="py-0 pr-4 pl-3">
        <!-- Pagada -->
         <v-col class="py-0" cols="3">
             <v-checkbox
                v-model="currentDocument.paid"
                :disabled="currentDocument.forced_move || !canChange()"
                label="Pagada"
                @change="setDirty()"
                class="checkbox-stylev2 label-text"
            ></v-checkbox>
         </v-col>
      </v-row>
      <v-row class="py-0 pr-4 pl-3" v-if="got_feature('feature_can_see_table_payment_methods')">
          <div style="display: flex;" v-if="document_kind == 'in_invoice'">
              <v-col class="py-0" cols="3">
                  <v-checkbox
                      v-model="document_is_cartera_active"
                      label="Pago auto."
                      class="checkbox-stylev2 label-text"
                      :disabled="isDisabledPaymentAutomatic()"
                      @change="onIsCarteraActiveChange"
                  />
              </v-col>
              <v-col class="py-0" cols="5">
                  <div style="display: flex; justify-content: center; align-items: center;">
                    <span 
                        :style="{
                            width: '55%',
                            color: isDisabledCarteraSuppliers()? '#6D6D6D' : '#454545', 
                            fontSize: '12px', 
                            fontWeight: '600'
                        }"
                    >
                        Método de pago
                    </span>
                    <v-select
                        v-model="document_payment_method_id"
                        :items="payment_methods"
                        :disabled="isDisabledCarteraSuppliers()"
                        item-value="payment_method_id"
                        item-text="name"
                        style="box-shadow: none; -webkit-box-shadow: none"
                        class="select-invoice-stylev2 activate-text remove-border-radius"
                        outlined
                        dense
                        solo
                        hide-details
                        append-icon="mdi-chevron-down"
                        @change="onPaymentMethodChange"
                    />
                  </div>
              </v-col>
              <v-col class="py-0" cols="4">
                <doc-text-field
                    v-model="document_cartera_account"
                    :disabled="isDisabledCarteraSuppliers()"
                    kind="text"
                    label="Cuenta de Pago"
                    stylev2
                    :class="{ disabled: isDisabledCarteraSuppliers() }"
                    @change="setDirty()"
                />
              </v-col>
          </div>
          <div style="display: flex;" v-else-if="document_kind == 'out_invoice'">
              <v-col class="py-0" cols="3">
                  <v-checkbox
                      v-model="document_is_cartera_active"
                      label="Cobro auto."
                      class="checkbox-stylev2 label-text"
                      :disabled="isDisabledChargeAutomatic()"
                      @change="onIsCarteraActiveChange"
                  />
              </v-col>
              <v-col class="py-0" cols="5">
                  <div style="display: flex; justify-content: center; align-items: center;">
                    <span 
                        :style="{
                            width: '55%',
                            color: isDisabledCarteraCustomers()? '#6D6D6D' : '#454545', 
                            fontSize: '12px', 
                            fontWeight: '600'
                        }"
                    >
                        Método de cobro
                    </span>
                    <v-select
                        v-model="document_payment_method_id"
                        :items="payment_methods"
                        :disabled="isDisabledCarteraCustomers()"
                        item-value="payment_method_id"
                        item-text="name"
                        style="box-shadow: none; -webkit-box-shadow: none"
                        class="select-invoice-stylev2 activate-text remove-border-radius"
                        outlined
                        dense
                        solo
                        hide-details
                        append-icon="mdi-chevron-down"
                        @change="onPaymentMethodChange"
                    />
                  </div>
              </v-col>
              <v-col class="py-0" cols="4">
                <doc-text-field
                    v-model="document_cartera_account"
                    :disabled="isDisabledCarteraCustomers()"
                    kind="text"
                    label="Cuenta de Cobro"
                    stylev2
                    :class="{ disabled: isDisabledCarteraCustomers() }"
                    @change="setDirty()"
                />
              </v-col>
          </div>
      </v-row>
      <v-row class="px-4 pb-3">
          <v-col :cols="show_retention_type_name?'2':'6'" class="py-1 pr-1">
              <metadata-field 
                  field-key="retention_type" 
                  :required="Boolean(currentDocument.metadata['retention_amount']) || (currentDocument.metadata['retention_amount'] == '0' && currentDocument.metadata['retention_type'] != '0')" 
                  :tabs="tabs" 
                  kind="number" 
                  field-text="% Ret." 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'retention_type'"
                  stylev2
                  :class="{
                    'disable-text': currentDocument.forced_move, 
                    'activate-text': !currentDocument.forced_move 
                  }"
              />
          </v-col>
          <v-col :cols="show_retention_type_name?'4':'6'" class="py-1 pr-1">
              <metadata-field 
                  field-key="retention_amount" 
                  :required="Boolean(currentDocument.metadata['retention_type'])  || (currentDocument.metadata['retention_type'] == '0' && currentDocument.metadata['retention_amount'] != '0')" 
                  :tabs="tabs" 
                  kind="number" 
                  field-text="Retención" 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'retention_amount'"
                  stylev2
                  :class="{
                    'disable-text': currentDocument.forced_move, 
                    'activate-text': !currentDocument.forced_move 
                  }"
              />
          </v-col>
          <v-col v-if="show_retention_type_name" cols="6" class="py-1">
              <v-autocomplete
                  autocomplete="off"
                  v-model="document_retention_type_name"
                  :items="filtered_retention_types"
                  class="autocomplete-input pa-0 select-invoice-stylev2 activate-text"
                  :hide-details="true"
                  :error="errorRetentionType"
                  outlined
                  dense    
                  append-icon="mdi-chevron-down"
              >
              <template v-slot:prepend>
                  <label>Tipo de Ret.</label>
              </template>
                  
              </v-autocomplete>
          </v-col>
      </v-row>
      <v-row class="px-4 pb-3">
        <!-- Autocomplete Field -->
        <v-col v-if="got_feature('feature_assign_fiscal_location')" cols="12" sm="6" md="15">
          <v-autocomplete
            v-model="currentDocument.fiscal_location"
            autocomplete="off"
            :items="fiscal_locations"
            :readonly="false"
            class="autocomplete-input pa-0 select-invoice-stylev2"
            :class="{'error-background': fiscal_location_error !== '' && false}"
            :hide-details="true"
            outlined
            dense
            @change="on_fiscal_location_changed"
          >
            <template v-slot:prepend>
                <label>Loc.Fiscal.</label>
            </template>
          </v-autocomplete>
        </v-col>
        <!-- Error Icon with Tooltip -->
        <v-col v-if="got_feature('feature_assign_fiscal_location') && this.fiscal_location_error !== ''" cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon 
                  v-bind="attrs" 
                  v-on="on" 
                  class="error--text" 
                  style="font-size: 20px;"
                > mdi-alert-circle
                </v-icon>
              </template>
              <span>{{ this.fiscal_location_error }}</span>
            </v-tooltip>
        </v-col>
    </v-row>
    </div> <!-- / Section Factura -->
    <div class="pb-4" v-if="!show_section_factura"></div>
  
    <v-tabs v-model="currentTab" class="tabs-taxs-invoice">
        <v-tab v-for="tab in visibleTabs" :key="tab.code">
            <div v-if="tab.code == 'params'">
                {{tab.text}} <v-icon v-if="someParamsError" color="red">mdi-alert</v-icon>
            </div>
            <div v-else>
                {{tab.text}}
            </div>
        </v-tab>
        
        <v-tab v-if="getInvoiceLines().length > 0" key="lineas_tab">
            Detalles  
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab" class="m-3 table-iva">
        
        <v-tab-item v-for="tab in visibleTabs" :key="tab.code">
            
            <div v-if="tab.code === 'iva'">
                
            </div>
        </v-tab-item>
        
        <v-tab-item v-if="getInvoiceLines().length > 0" key="lineas_content" class="v-application ma-1">
            <v-simple-table dense outlined class="bordered-table">
                <thead>
                    <tr>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                        <th>Precio Unitario</th>
                        <th>Tipo de Impuesto</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(line, index) in getInvoiceLines()" :key="index">
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="description-cell" v-bind="attrs" v-on="on">{{ line.description }}</span>
                                </template>
                                <span>{{ line.description }}</span>
                            </v-tooltip>
                        </td>
                        <td>{{ line.quantity }}</td>
                        <td>{{ line.unit_price_without_tax }}</td>
                        <td>{{ line.tax_rate }}</td>
                        <td>{{ line.total_amount }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-tab-item>
        
    </v-tabs-items>

    <div v-show="show_section_taxes">
      <v-tabs-items v-model="currentTab" v-if="currentDocument" class="ma-3 table-iva">
          <v-tab-item
              :key="tab.code+'1'"
              v-for="tab in visibleTabs"
          >
              <div v-if="tab.code == 'params'" >
              <v-row no-gutters>
                  <v-col cols="12">
                      <v-row v-if="got_feature('feature_serie_in_docs')">
                          <v-col cols="8">
                              <doc-text-field 
                                  kind="text" 
                                  @change="setDirty()"
                                  v-model="document_serie" 
                                  label="Serie"
                                  stylev2
                              />
                          </v-col>
                      </v-row>
                      <v-row v-if="showTypes0Error">
                          <v-col cols="8">
                              <div style="color:red">
                                  Las facturas intracomunitarias o con inversion del sujeto pasivo no admiten los impuestos de esta factura.
                              </div>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="8">
                              <v-radio-group class="radio-group-stylev2" v-model="selectedParam" @change="resetParamOption" :key="selectedParam">
                                  <div @click="toggleParam">
                                      <v-radio
                                      :disabled="currentDocument.forced_move || !canChange()"
                                      value="inversion_sujeto_pasivo_iva" label="Inversión sujeto pasivo IVA" />
                                  </div>
                                  <div @click="toggleParam">
                                      <v-radio
                                      :disabled="currentDocument.forced_move || !canChange()"
                                      value="inversion_sujeto_pasivo_igic" label="Inversión sujeto pasivo IGIC" />
                                  </div>
                                  <div @click="toggleParam">
                                      <v-radio
                                      :disabled="currentDocument.forced_move || !canChange()"
                                      value="intracomunitario" label="Intracomunitario" />
                                  </div>
                                  <div @click="toggleParam"  v-if="currentDocument.kind=='out_invoice' || selectedParam == 'extracomunitario' || got_feature('feature_extra_supplier')">
                                      <v-radio
                                      :disabled="currentDocument.forced_move || !canChange()"
                                      value="extracomunitario" label="Extracomunitario" />
                                  </div>
                                  <div @click="toggleParam" v-if="feature_supplier_comerciante_minorista && currentDocument.kind=='in_invoice'"> <!-- Este feature es un computed que usa got_feature -->
                                      <v-radio
                                          :disabled="currentDocument.forced_move || !canChange()"
                                          value="is_comerciante_minorista" 
                                          label="Comerciante Minorista" 
                                      />
                                  </div>
                                  <div @click="toggleParam" v-if="feature_no_sujeta">
                                      <v-radio
                                      :disabled="currentDocument.forced_move || !canChange()"
                                      value="no_sujeta" label="No sujeta" />
                                  </div>
                                  <div @click="toggleParam" v-if="currentDocument.kind=='out_invoice' && got_feature('feature_foreign_entity')">
                                      <v-radio
                                      :disabled="currentDocument.forced_move || !canChange()"
                                      value="foreign_entity" label="Entidad extranjera" />
                                  </div>
                              </v-radio-group>
                          </v-col>
                          <v-col cols="4" v-if="selectedParam && (PROVIDER_SOMETHING_OPTIONS[selectedParam] || PROVIDER_SOMETHING_OPTIONS2[selectedParam])">
                              <v-autocomplete
                                  class="select-invoice-stylev2"
                                  v-model="selectedParamOption"
                                  v-if="currentDocument.kind=='in_invoice'"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  autocomplete="off"
                                  :items="PROVIDER_SOMETHING_OPTIONS[selectedParam]"
                                  :background-color="taxTypesDoNotMatch ? '#ff9898' : '#ffffff'"
                                  :readonly="currentDocument.forced_move || !canChange()"
                                  outlined
                                  dense    
                                  append-icon="mdi-chevron-down"
                                  :class="{
                                    'disable-text': currentDocument.forced_move, 
                                    'activate-text': !currentDocument.forced_move 
                                  }"             
                              >
                                  <template v-slot:prepend>
                                      <label>{{selectedParam === 'extracomunitario' ? 'Importaciones' : 'Porcentaje'}}</label>
                                  </template>
                              </v-autocomplete>
                              <v-autocomplete
                                  v-if="(selectedParam == 'intracomunitario' && feature_intra_type) || (selectedParam == 'extracomunitario' && (feature_extra_type || feature_extracomunitario_type)) || (selectedParam == 'foreign_entity' && got_feature('feature_foreign_entity'))"
                                  class="select-invoice-stylev2"
                                  v-model="selectedParamOption2"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  autocomplete="off"
                                  :items="PROVIDER_SOMETHING_OPTIONS2[selectedParam]"
                                  :readonly="currentDocument.forced_move || !canChange()"
                                  outlined
                                  dense    
                                  append-icon="mdi-chevron-down"                
                              >
                                  <template v-slot:prepend>
                                      <label>Tipo</label>
                                  </template>
                              </v-autocomplete>
                          </v-col>
                      </v-row>
                      <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light"/>
                      <v-row v-if="feature_bien_inversion">
                          <v-col cols="8" class="ml-3 pa-0 ma-0 pt-1">
                              <v-checkbox class="checkbox-stylev2"
                              @change="checkBienInversion()"
                              :disabled="currentDocument.forced_move || !canChange()"
                              v-model="document_bien_inversion" label="Bienes de inversión" />
                          </v-col>
                      </v-row>
                      <v-row v-if="got_feature('feature_rebu')">
                          <v-col cols="4" class="ml-3 pa-0 ma-0 pt-1">
                              <v-checkbox class="checkbox-stylev2"
                              @change="checkRebu()"
                              :disabled="currentDocument.forced_move || !canChange()"
                              v-model="document_rebu" label="REBU" />
                          </v-col>
                          <v-col cols="6" v-if="document_rebu && currentDocument.kind === 'out_invoice'" class="pa-0 ma-0 pt-1">
                              <doc-text-field
                                  kind="number"
                                  label="Precio Compra"
                                  v-model="document_rebu_precio_compra"
                                  :readonly="currentDocument.forced_move || !canChange()"
                                  @change="setDirty()"
                                  :required="true"
                                  :error="showRequiredRebu || (document_rebu && currentDocument.kind === 'out_invoice' && !document_rebu_precio_compra)"
                                  stylev2
                              ></doc-text-field>
                          </v-col>
                      </v-row>
                      <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light" v-if="got_feature('feature_rebu')"/>
                      <v-row v-if="currentDocument.kind=='in_invoice'">
                          <v-col cols="7">
                              <v-tooltip top :disabled="!noDeducibleCheckError && !isComercianteMinoristaCheckError">
                                  <template v-slot:activator="{ on, attrs }">
                                      <div v-bind="attrs" v-on="on">
                                          <v-radio-group class="radio-group-stylev2" v-model="selectedIvaCheck" :error="noDeducibleCheckError || isComercianteMinoristaCheckError">
                                              <div @click="toggleParamIva">
                                                  <v-radio
                                                  :disabled="currentDocument.forced_move || !canChange()"
                                                  value="iva_igic_no_deducible" label="IVA/IGIC no deducible" />
                                              </div>
                                              <div @click="toggleParamIva" v-if="feature_gasto_iva_parcial">
                                                  <v-radio
                                                  :disabled="currentDocument.forced_move || !canChange()"
                                                  value="gasto_iva_parcial" label="Gasto+IVA deducible parcialmente" />
                                              </div>
                                              <div @click="toggleParamIva" v-if="feature_iva_deducible_parcialmente">
                                                  <v-radio
                                                  :disabled="currentDocument.forced_move || !canChange()"
                                                  value="iva_parcial" label="IVA deducible parcialmente" />
                                              </div>
                                              <div @click="toggleParamIva" v-if="feature_prorate && currentDocument.kind == 'in_invoice' && currentDocument.companydb_info.prorate && currentPath()['prorate_percent'] != 'N/A'">
                                                  <v-radio
                                                  :disabled="currentDocument.forced_move || !canChange()"
                                                  value="prorate" label="Prorrata" />
                                              </div>
                                          </v-radio-group>
                                      </div>
                                  </template>
                                  <span v-if="noDeducibleCheckError">Funcionalidad no soportada: Factura con IVA/IGIC no deducible e {{(selectedParam=='intracomunitario' && 'Intracomunitario') || (selectedParam=='inversion_sujeto_pasivo_iva' && 'Inversión sujeto pasivo IVA') || (selectedParam=='inversion_sujeto_pasivo_igic' && 'Inversión sujeto pasivo IGIC')}}.</span>
                                  <span v-if="isComercianteMinoristaCheckError">Funcionalidad no soportada: Factura con Comerciante Minorista y Deducibilidad.</span>
                              </v-tooltip>
                          </v-col>
                          <v-col cols="5">
                              <v-checkbox
                                  v-if="selectedIvaCheck=='iva_igic_no_deducible' && feature_comerciante_minorista && currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('comerciante_minorista')))"
                                  class="checkbox-stylev2"
                                  :disabled="currentDocument.forced_move || !canChange()"
                                  label="Registrar en libro de facturas"
                                  v-model="document_comerciante_minorista"
                              ></v-checkbox>
                              <doc-text-field
                                  v-if="selectedIvaCheck=='gasto_iva_parcial' || selectedIvaCheck=='iva_parcial'"
                                  kind="number"
                                  label="Porcentaje"
                                  v-model="document_gasto_iva_percent"
                                  :readonly="currentDocument.forced_move || !canChange()"
                                  :required="true"
                                  :error="document_gasto_iva_percent<=0 || document_gasto_iva_percent>=100 || (document_errorJson.length > 0 && document_errorJson.includes('gasto_iva_percent'))"
                                  stylev2
                              ></doc-text-field>
                          </v-col>
                      </v-row>
                      <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light" v-if="currentDocument.kind=='in_invoice'" />
                  </v-col>
              </v-row>
              <v-row v-if="feature_building_code && currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('building_code')" no-gutters>
                  <v-col cols='12'>
                     <doc-text-field 
                          kind="text" 
                          @change="setDirty()"
                          :readonly="!canChange()"
                          stylev2
                          v-model="document_building_code" label="Código de inmueble" />
                  </v-col>
              </v-row>
              <template v-if="feature_criterio_de_caja || showApplyModelo() || showApply415()">
                <v-row class="pt-2 pb-1" no-gutters>
                    <v-col cols='12' v-if="showApply415()">
                        <v-checkbox
                            class="checkbox-stylev2"
                            kind="text" 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_apply_415" 
                            label="Aplica 415" 
                        />
                    </v-col>
                    <v-col cols='6' v-else-if="showApplyModelo()">
                        <v-checkbox 
                            class="checkbox-stylev2"
                            kind="text" 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_apply_modelo" 
                            :label="apply_modelo_label" 
                        />
                    </v-col>
                    <v-col cols="6" v-if="feature_criterio_de_caja">
                        <v-checkbox 
                            class="checkbox-stylev2" 
                            @change="setDirty()"
                            :disabled="!canChange()"
                            v-model="document_criterio_de_caja" 
                            label="Criterio de Caja" />
                    </v-col>
                </v-row>
              </template>
                <v-row v-if="feature_building_code && currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('building_code')" no-gutters>
                    <v-col cols='12'>
                        <doc-text-field 
                            kind="text" 
                            @change="setDirty()"
                            :readonly="!canChange()"
                            stylev2
                            v-model="document_building_code" label="Código de inmueble" />
                    </v-col>
                </v-row>
                <!-- <template v-if="feature_criterio_de_caja || showApplyModelo() || (got_feature('feature_apply_415') && currentCompany.apply_415)">
                    <v-row class="pt-2 pb-1" no-gutters>
                        <v-col cols='6' v-if="showApplyModelo()">
                            <v-checkbox 
                                class="checkbox-stylev2"
                                kind="text" 
                                @change="setDirty()"
                                :disabled="!canChange()"
                                v-model="document_apply_modelo" 
                                :label="apply_modelo_label" 
                            />
                        </v-col>
                        <v-col cols='12' v-if="got_feature('feature_apply_415') && currentCompany.apply_415">
                            <v-checkbox 
                                kind="text" 
                                @change="setDirty()"
                                :disabled="!canChange()"
                                v-model="document_apply_415" 
                                label="Aplica 415" 
                            />
                        </v-col>
                        <v-col cols="6" v-if="feature_criterio_de_caja">
                            <v-checkbox 
                                class="checkbox-stylev2" 
                                @change="setDirty()"
                                :disabled="!canChange()"
                                v-model="document_criterio_de_caja" 
                                label="Criterio de Caja" />
                        </v-col>
                    </v-row>
                </template> -->
                <v-row>
                    <v-col cols="12">                                                               
                        <v-checkbox v-if="!(rectification_invoice===undefined)" 
                            class="checkbox-stylev2"   
                            :disabled="!canChange()"
                            v-model="rectification_invoice"
                            @change="toggleIsRectificativa" 
                            label="Factura rectificativa"/>

                    </v-col>
                </v-row>
                <v-row v-if="showRectifyFields()">
                    <v-col :cols="got_feature('feature_invoice_date_to_rectify')?'6':'12'">
                        <autocomplete-with-api
                            label="Nº factura rectificada"
                            :can_add_new="true"
                            v-model="invoice_to_rectify"
                            :starting_items="[]"
                            :url="url_get_invoices_to_rectify"
                            item_text="inv_number"
                            search_field_name="metadata__inv_number__icontains"
                            item_search_field="inv_number"
                            :return_object="true"
                            :disabled="!canChange()"                          
                            classes="ma-0 pa-0 select-invoice-stylev2"
                            @input="changeInvNumberToRectify"
                            :bck_color="inv_number_to_rectify_error?'#ff9898':'#ffffff'"
                            stylev2
                        ></autocomplete-with-api>
                    </v-col>
                    <v-col cols="6" v-if="got_feature('feature_invoice_date_to_rectify')">
                        <doc-text-field 
                            kind="date" 
                            label="Fecha factura rectificada"
                            v-model="document_inv_date_to_rectify"
                            :error="inv_date_to_rectify_error"
                            :readonly="!canChange()"
                            stylev2
                        ></doc-text-field >
                    </v-col>
                </v-row>
                <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light" />
                <v-row class="pt-2" v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type.type == 'invoice' && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('prefix_invoice'))))" no-gutters>
                    <v-col cols='12'>
                        <v-checkbox @change="setDirty()"
                            class="checkbox-stylev2"                          
                            :disabled="!canChange()"
                            v-model="document_written_description" label="Personalizar descripción" />
                    </v-col>
                </v-row>
                <v-row v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type.type == 'invoice' && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('prefix_invoice'))))" no-gutters>
                    <v-col cols='12' class="pb-2 px-1">
                        <doc-text-field 
                            kind="text" 
                            @change="setDirty()"
                            :readonly="!document_written_description || !canChange()"
                            stylev2
                            v-model="document_description" label="Descripción" />
                    </v-col>
                </v-row>

                <v-row v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii">
                    <v-col cols='12' class="py-0">
                        <v-checkbox @change="setDirty()"
                            class="checkbox-stylev2"                          
                            :disabled="!canChange()"
                            v-model="document_written_description_sii" label="Personalizar descripción SII" />
                    </v-col>
                </v-row>
                <v-row v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii">
                    <v-col cols='12' class="pt-0 pb-2">
                        <doc-text-field 
                            kind="text" 
                            @change="setDirty()"
                            :readonly="!document_written_description_sii || !canChange()"
                            v-model="document_description_sii" 
                            label="Descripción SII" 
                            stylev2
                            :error="showRequiredDescriptionSII"/>
                    </v-col> 
                </v-row>
                <div class="ma-0 pa-0" v-if="got_feature('feature_automatic_moves_in_document') && !got_feature('feature_can_see_table_payment_methods')">    
                    <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light" />    
                    <v-row v-if="document_kind == 'in_invoice'">
                        <v-col cols="3">
                            <doc-text-field
                            kind="text"
                            disabled
                            v-model="automaticPaymentAccountLabel"
                            label="Pago auto."
                            stylev2
                            />
                        </v-col>
                        <v-col class="d-flex align-center" cols="9">
                            <doc-text-field
                                kind="text"
                                :label="cru_label_payment_account"
                                v-model="document_payment_account"
                                stylev2
                            />
                        </v-col>
                    </v-row>
                    <v-row v-else-if="document_kind == 'out_invoice'">
                        <v-col cols="3">
                            <doc-text-field
                                kind="text"
                                disabled
                                v-model="automaticChargeAccountLabel"
                                label="Cobro auto."
                                stylev2
                            />
                        </v-col>
                        <v-col cols="9">
                            <doc-text-field
                                kind="text"
                                v-model="document_charge_account"
                                :label="cru_label_charge_account"
                                stylev2
                            />
                        </v-col>
                    </v-row>
                </div>
              </div>
              <v-row v-else no-gutters>
                                   
                  <template v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice' && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas">
                      <v-col cols="2" class="text-center table-head-invoice">Tipo</v-col>
                      <v-col cols="3" class="text-center table-head-invoice">Base</v-col>
                      <v-col cols="3" class="text-center table-head-invoice">Cuota</v-col>
                      <v-col cols="4" class="text-center table-head-invoice">Cuenta</v-col>
                  </template>
                  <template v-else>
                      <v-col :cols="get_tipo_cols()" class="text-center table-head-invoice">Tipo</v-col>
                      <v-col cols="4" class="text-center table-head-invoice">Base</v-col>
                      <v-col :cols="get_cuota_cols()" class="text-center table-head-invoice">Cuota</v-col>
                      <v-tooltip top v-if="typeCheckRet != 'none'">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn  v-bind="attrs" 
                                          v-on="on"
                                          :key="'ampl'" 
                                          small  
                                          color="primary"
                                          icon
                                          @click="conf_ret_button=!conf_ret_button"
                                          :style="{'margin-left':cusRetMarginLeft}"
                                          class="table-head-invoice-btn"
                                          >
                                      <v-icon >mdi-dots-vertical</v-icon>
                                  </v-btn>
                              </template>
                          <span v-if="!showCustomRet"> Mostrar columna base retención</span>
                          <span v-else-if="!hasSomeCustomRet"> Ocultar columna</span>
                      </v-tooltip>
                      <template v-if="showCustomRet && typeCheckRet != 'none'">
                          <v-col cols="2" v-if="typeCheckRet=='checkbox'" class="text-center table-head-invoice" :style="{'margin-left':'7px'}">Apl. Ret.</v-col>
                          <v-col cols="2" v-else-if="typeCheckRet=='base'" class="text-center table-head-invoice" :style="{'margin-left':'7px'}">Base Ret.</v-col>
                      </template>
                  </template>
                  <template v-for="vat in tab.vats" >
                      <template v-if="currentDocument && (show_empty_vats || showVatRow(currentDocument.metadata, vat))">
                        <template v-if="currentCompany && show_vat(vat.vat)">
                          <template v-if="Boolean(currentDocument.metadata['detail_'+vat.vat]) && currentDocument.metadata['detail_'+vat.vat].length>0">
                              <v-col :key="'label_'+vat.vat" cols="2" class="text-center table-row-invoice">
                                  <doc-text-field 
                                      kind="text"
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                  />
                              </v-col>
                              <v-col :key="'base_'+vat.vat" cols="3" class="text-center table-row-invoice">
                                  <metadata-field 
                                      kind="detail_number" 
                                      :field-key="'base_'+vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'base_'+vat.vat"
                                      :initial_error="document_errorJson && document_errorJson.constructor === Array && document_errorJson.includes('base_'+vat.vat)"
                                  />
                              </v-col>
                              <v-col :key="'vat_'+vat.vat" cols="3" class="text-center table-row-invoice">
                                  <metadata-field 
                                      kind="detail_number" 
                                      :field-key="vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+vat.vat"
                                  />  
                              </v-col>
                              <v-col :key="'account_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                  <v-row no-gutters>
                                      <v-col cols="10">
                                          <metadata-field 
                                              kind="detail_account" 
                                              :field-key="vat.vat" 
                                              field-text="" 
                                              :key="currentDocument.id.toString()+isWaitingFlow.toString()+'account_'+vat.vat"
                                          />
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn :key="'dialog_'+vat.vat" small @click="dialog_vat=vat; show_account_detail=true"
                                              color="primary"
                                              icon
                                              max-width="20"
                                              max-height="20"
                                              >                                              
                                              <AppIcon src="/invoices/row_edit.svg" :size="20" /> 
                                          </v-btn>
                                      </v-col>
                                  </v-row>
                                  
                                  
                              </v-col>
                          </template>
                          <template v-else-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice' && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas">
                              <v-col :key="'label_'+vat.vat" cols="2" class="table-row-invoice" >
                                  <doc-text-field 
                                      v-if="vat.vat.includes('_re_')"
                                      kind="text" 
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                  />
                                   <doc-text-field 
                                      v-else
                                      kind="text" 
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                  />
                              </v-col>
                              <v-col :key="'vat_'+vat.vat" cols="3" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata[vat.vat])" 
                                      :field-key="'base_'+vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'base_'+vat.vat"
                                      :fill-account="vat.vat"
                                      :initial_error="document_errorJson && document_errorJson.constructor === Array && document_errorJson.includes('base_'+vat.vat)"
                                  />
                              </v-col>
                              <v-col :key="'base_'+vat.vat" cols="3" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                                      :field-key="vat.vat" 
                                      :field-check="['base_'+vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+vat.vat"
                                      :fill-account="vat.vat"
                                  />
                              </v-col>
                              <v-col :key="'account_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                  <v-row no-gutters>
                                      <v-col cols="10">
                                          <metadata-field 
                                              :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                                              :required="Boolean(currentDocument.metadata['account_'+vat.vat])" 
                                              :field-key="'account_'+vat.vat" 
                                              field-text="" 
                                              :key="currentDocument.id.toString()+isWaitingFlow.toString()+'account_'+vat.vat"
                                              :num_digits="currentDocument.companydb_info.num_digits"
                                              :items="got_feature('feature_accounts_master') ? accounts : []"
                                              @get-values="getValues"
                                              @reset-items="resetItems"
                                          />
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn :key="'dialog_'+vat.vat" @click="dialog_vat=vat; show_account_detail=true"
                                              color="primary"
                                              icon
                                              >
                                              <img v-if="permission.is_readonly|| (currentDocument.forced_move && !editableForcedMove) || (currentDocument && (['pending','running'].includes(currentDocument.async_job_state) || ['pending_connect','accounting_aplifisa_fiscal', 'accounting_invoice'].includes(currentDocument.state)))" src="/invoices/eye.png" width="11" height="11">
                                              <AppIcon src="/invoices/row_edit.svg" :size="20" v-else />
                                          </v-btn>
                                      </v-col>
                                  </v-row>
                                  
                              </v-col>
                          </template >
                          <template v-else>
                              <v-col :key="'label_'+vat.vat" :cols="get_tipo_cols()" class="table-row-invoice">
                                  <doc-text-field 
                                      kind="text" 
                                      readonly 
                                      :value="get_label(vat)" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                      class="disable-text"
                                  />
                              </v-col>
                              <v-col :key="'vat_'+vat.vat" cols="4" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata[vat.vat])" 
                                      :field-key="'base_'+vat.vat" 
                                      :field-check="[vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                      :class="{
                                        'disable-text': currentDocument.forced_move, 
                                        'activate-text': !currentDocument.forced_move 
                                      }"
                                  />
                              </v-col>
                              <v-col :key="'base_'+vat.vat" :cols="get_cuota_cols()" class="table-row-invoice">
                                  <metadata-field 
                                      kind="number" 
                                      :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                                      :field-key="vat.vat" 
                                      :field-check="['base_'+vat.vat,vat.coef]" 
                                      field-text="" 
                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                      :class="{
                                        'disable-text': currentDocument.forced_move, 
                                        'activate-text': !currentDocument.forced_move 
                                      }"
                                  /></v-col>
                              <template v-if="showCustomRet">
                                  <v-col v-if="typeCheckRet == 'checkbox'" :key="'check_ret_'+vat.vat" cols="2" class="table-row-invoice">
                                      <metadata-field v-if="!vat.vat.includes('_re_') " :field-key="'not_ret_'+vat.vat" kind="boolean" field-text="" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'checkret'"/>
                                  </v-col>
                                  <v-col v-else-if="typeCheckRet == 'base'" :key="'check_ret_'+vat.vat" cols="2" class="table-row-invoice">
                                      <metadata-field v-if="!vat.vat.includes('_re_') " 
                                                      :field-key="'ret_base_'+vat.vat" 
                                                      :field-check="['base_'+vat.vat,vat.coef]" 
                                                      kind="number" 
                                                      field-text="" 
                                                      :key="currentDocument.id.toString()+isWaitingFlow.toString()+'baseret'"/>
                                  </v-col>
                              </template>
                          </template>
                      </template>                      
                    </template>
                  </template>
                  <v-btn @click="show_empty_vats=!show_empty_vats" outlined dense class="mt-1 btn-show-empty-vats">
                    <template v-if="show_empty_vats"><v-icon>mdi-arrow-up</v-icon>Ocultar líneas vacías</template>
                    <template v-else><v-icon>mdi-arrow-down</v-icon>Mostrar toda la tabla</template>
                </v-btn>
              </v-row>
              
          </v-tab-item>
      </v-tabs-items>
      <v-row v-if="currentDocument" class="px-4">
          <v-col cols="12" offset="1" sm="5">
              <metadata-field v-if="currentDocument.companydb_info && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('other_amounts'))))"
                  field-key="other_amounts" 
                  kind="number" 
                  field-text="SUPLIDOS"
                  stylev2 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'other_amounts'"
                  :initial_error="document_errorJson && document_errorJson.constructor === Array && document_errorJson.includes('other_amounts')"
                  :class="{
                    'disable-text': currentDocument.forced_move, 
                    'activate-text': !currentDocument.forced_move 
                  }"
               />
          </v-col>
          <v-col cols="12" sm="6">
              <metadata-field 
                class="label-bold" 
                field-key="total_amount" 
                kind="number" 
                :required="true" 
                :tabs="tabs" 
                field-text="TOTAL FACTURA" 
                :key="currentDocument.id.toString()+isWaitingFlow.toString()+'total_amount'" 
                stylev2 
                :class="{
                    'disable-text':currentDocument.forced_move, 
                    'activate-text': !currentDocument.forced_move,
                    'highlight-important-field': isImportantField()
                }"
                />
          </v-col>
      </v-row>
      
      <!-- Currency -->
      <v-row class="px-4" v-if="userData.available_features['feature_see_currency'] && currentDocument && currentDocument.currency && !buzonView && !pending_states.includes(currentDocument.state)">
        <v-col cols="6"  offset-sm="6" class="divisa py-1">
          <v-tooltip top v-if="currentDocument && !('detected_amounts' in currentDocument.metadata) && currentDocument.currency != 'EUR' &&
            !['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"                
                class="ml-1 mb-2 mr-2 btn-invoice-detail-divisa"
                :loading="loading_update_currency"
                @click="update_divisa"
                :disabled="dirty">
                a EUR
              </v-btn>
            </template>
            <span>Actualizar valores a EUR</span>
          </v-tooltip>
          <v-tooltip top v-if="currentDocument && 'detected_amounts' in currentDocument.metadata">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"                
                class="ml-1 mb-2 mr-2 btn-invoice-detail-divisa"
                :loading="loading_restore_detected"
                @click="restore_detected"
                >
                a {{ currentDocument.currency }}
              </v-btn>
            </template>
            <span>Recuperar valores detectados</span>
          </v-tooltip>
          <doc-text-field 
            v-if="available_currencies.length <= 0"
            v-model="currentDocument.currency"
            @change="setDirty()"
            label="Divisa"
            readonly
            :disabled="['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
            stylev2
            class="disable-text"
          ></doc-text-field>
          <v-select
            v-else
            class="select-invoice-stylev2"
            :items="available_currencies"          
            v-model="currentDocument.currency"
            @change="currencyHasChanged()"
            :disabled="['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
            outlined
            dense
            append-icon="mdi-chevron-down"
          >
            <template v-slot:prepend>
              <label>Divisa</label>
            </template>     

          </v-select>
          
        </v-col>

      </v-row>

      <v-row v-if="currentDocument && currentDocument.metadata && 'detected_amounts' in currentDocument.metadata && currency_info" class="under__text__divisa pt-0">
        <v-col cols="6" offset-md="6" class="pt-0">
          <span><strong>Tipo de cambio:</strong> {{ currency_info.name }} a EUR en fecha {{ currency_info.date }} con valor {{ currency_info.value }}.</span>
        </v-col>
      </v-row>
      <!-- /Currency -->

      <!-- Dialog show detectes values -->
      <v-dialog persistent v-model="show_popup_message_restore" max-width="600">
          <v-card>
            <v-card-title>
              <span class="text-h5 font-weight-bold py-1 ml-2">Aviso</span>
            </v-card-title>
            <v-divider></v-divider>
            <p class="px-3 ml-6 pt-5">¿Esta seguro que quiere restablecer las bases y cuotas?</p>
            <span class="primary--text px-3 ml-6">Bases y cuotas detectadas:</span>
            <v-card-text>
              <invoice-detected-info :key="currentDocument.id" v-if="currentCompany && currentDocument && ['in_invoice','out_invoice'].includes(currentDocument.kind)" />
            </v-card-text>
            <v-card-actions class="px-6">
              <v-spacer></v-spacer>
              <v-btn
                variant="text"
                @click="confirmRestoreDetected(false)"
              >
                Cancelar
              </v-btn>
              <v-btn
                variant="text"
                @click="confirmRestoreDetected(true)"
                color="primary"
                :disabled="currentDocument && ['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <message-popup 
            title="Aviso"
            :show_message="show_popup_message"  
            :message="`<p>¿Esta seguro que quiere modificar las bases y cuotas a la divisa EUR ?</p>`"
            :actions="[{ 'action_text': 'Cancelar', 'emit': 'close-message' }, { 'action_text': 'Aceptar', 'emit': 'confirm-update-data', 'prin': true }]"
            @close-message="confirmCurrency(false)" 
            @confirm-update-data="confirmCurrency(true)"
        ></message-popup>

    </div>
    <div class="pb-4" v-if="!show_section_taxes"></div>
  </div>
</template>

<script>
import _ from 'lodash'
import MetadataField from './MetadataField.vue'
import DocTextField from './DocTextField.vue'
import DetailAccounts from './DetailAccounts.vue'
import AutocompleteWithApi from './AutocompleteWithApi.vue'
import ViesValidator from './ViesValidator.vue'
import DatePicker from './DatePicker.vue'
import {mapFieldsMetadata} from "../store/vuex_utils"
import { STANDARD_LABELS_CLIENT } from "../store/constants";

import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import {vuexPrefix} from "../store/vuex_utils"
import { PROVIDER_SOMETHING_OPTIONS } from '../store/constants.js';
import { PROVIDER_SOMETHING_OPTIONS2 } from '../store/constants.js';
import { dateIsInPaths } from '../utils';
import { showErrorRetentionType } from "../modules/invoices/domain/Invoice"
import { ACCOUNTING_DATE_OPTIONS, REGISTRO_DATE_OPTIONS } from '../store/constants.js';
import { GetCurrencyCodeListQuery } from "@/modules/invoices/app/GetCurrencyCodeListQuery";
import { UpdateMetadataCurrencyCommand } from "@/modules/invoices/app/UpdateMetadataCurrencyCommand";
import { RestoreDetectedAmountsCommand } from "@/modules/invoices/app/RestoreDetectedAmountsCommand";
import { GetCurrencyInfoQuery } from "@/modules/invoices/app/GetCurrencyInfoQuery";
import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import MessagePopup from '../components/MessagePopup.vue';
import InvoiceDetectedInfo from './InvoiceDetectedInfo.vue';
import { GetFiscalLocationInfoQuery } from "@/modules/invoices/app/GetFiscalLocationInfoQuery";

import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"

import { invoiceAndFutureDateErrors, inAccountingPeriodErrors, diff5Years, unmatchingThirdError } from "@/modules/invoices/domain/Invoice"
import { PaymentMethodAPI } from "@/modules/company/infra/PaymentMethodAPI";

  export default {
      name:'InvoiceInfoV2',
      components:{
          MetadataField,
          DocTextField,
          DetailAccounts,
          AutocompleteWithApi,
          ViesValidator,
          DatePicker,
          MessagePopup,
          InvoiceDetectedInfo,
      },
      props: {
        show_section_factura: {
            default: true,
        },
        show_section_taxes: {
            default: true,
        },
      },
      created() {
          this.accounts = [];
          this.rectification_invoice = this.is_rectificativa;            
      },
      computed:{
          ...mapState('tax_tab', ['vat', 'igic']),
          ...mapGetters({
              currentDocument: "documents/currentDocument",
              isWaitingFlow: "documents/isWaitingFlow",
              documentFetched: 'documents/documentFetched',
              automaticPaymentAccount: 'documents/automatic_payment_account',
              automaticChargeAccount: 'documents/automatic_charge_account',
              dirty: 'documents/dirty',
              suppliers: "get_suppliers",
              customers: "get_customers",
              userData: "me/userData",
              currentCompany:"getCurrentCompany",
              fixMotxo:'fixMotxo',
              tabs: "tax_tab/getInitialTab",
              get_retention_types: 'get_retention_types_docs',
              permission: 'permissions/permission',
              got_feature: 'got_feature',
          }), 
          ...mapGetters('documents',['sumBasesIva','sumBasesIgic','sumBases','has_meta_igic','has_meta_iva','has_meta_igi','sumBasesIgi']),
          ...mapFields('documents',vuexPrefix('document_',[
              'kind','state','bien_inversion','rebu','rebu_precio_compra','supplierdb','customerdb','supplierdb_info','customerdb_info','comerciante_minorista',
              'gasto_iva_percent', 'errorJson','written_description','description', 'prorate','building_code','apply_modelo', 'apply_415', 'serie',
              'doc_number', 'retention_type_name', 'criterio_de_caja', 'written_description_sii', 'description_sii', 'payment_account', 'charge_account',
              'is_comerciante_minorista', 'inv_number_to_rectify', 'inv_date_to_rectify', 'doc_number_prefix', 'doc_number',
              'is_cartera_active', 'payment_method_id', 'cartera', 'cartera_account',
          ],'document.')),
          // ...mapFields(['showModalSupplier','showModalCustomer']),
          ...mapFields('me',vuexPrefix('',[
              'feature_comerciante_minorista', 'feature_no_sujeta', 'feature_bien_inversion', 'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_gasto_iva_parcial',
              'feature_prorate','feature_building_code','feature_iva_deducible_parcialmente','feature_apply_347','feature_vat_5',
              'feature_search_thirds_by_api', 'feature_base_retention', 'feature_see_albaran', 'feature_customer_retention_type', 
              'feature_retention_accounts_agrario', 'feature_criterio_de_caja', 'feature_expens_account_metadata'
          ],'userData.available_features.')),
          ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
          ...mapFields('cru',['accounts', 'label_automatic_payment_account']),
          ...mapFields('cru', vuexPrefix('cru_label_', ['payment_account', 'charge_account'], 'inputLabels.')),
          ...mapActions({
              setSuppliers: "setSuppliersPromise",
          }),
          ...mapFields('documents', ['selectedParam', 'selectedParamOption', 'selectedParamOption2', 'selectedIvaCheck']),
          currentTab:{
              get(){

                  if(this.clickedTab!=undefined){
                      return this.clickedTab
                  }else if(typeof(this.sumBasesIva)=='string' || typeof(this.sumBasesIgi)=='string'){
                      return 0
                  }else if(typeof(this.sumBasesIgic)=='string'){
                      if(this.currentCompany.tax_type.includes('iva'))
                          return 1
                      else
                          return 0
                  }else{
                      if(this.currentCompany && this.currentCompany.tax_type && this.currentCompany.tax_type.includes('iva') && this.currentCompany.tax_type.includes('igic')){
                          return Math.abs(this.sumBasesIva)>=Math.abs(this.sumBasesIgic)?0:1
                      }
                      return 0
                  }   
              },
              set(newValue){
                  if(newValue!=this.currentTab)
                      this.clickedTab=newValue
              },
          },
          errorInvoiceDate() {
            return this.future_errors.invoice || this.date_errors.invoice || this.error5years === true
          },
          invoiceTooltip() {
            if (this.future_errors.invoice) return this.date_tooltips.no_future_date
            else if (this.error5years === true) return this.date_tooltips.acc_inv_5y
            else return ""
          },
          errorAccountingDate() {
            return this.future_errors.accounting || this.date_errors.accounting || this.inAccounting_errors.accounting
          },
          errorAccountingDateSelect() {
            return this.errorAccountingDate && this.currentDocument.accounting_date_config != 'configurated'
          },
          accountingTooltip() {
            if (this.future_errors.accounting) return this.date_tooltips.no_future_date
            else return this.inAccounting_errors.accounting ? this.date_tooltips.no_acc_period : this.date_tooltips.acc_date_before_invoice
          },
          errorRegistroDate() {
            // return this.future_errors.registro || this.date_errors.registro || this.inAccounting_errors.registro
            // checks of accounting period + future date removed
            return this.date_errors.registro // this only checks 'registro_date' (not null) + (not before invoice date)
          },
          errorRegistroDateSelect() {
            return this.errorRegistroDate && this.currentDocument.registro_date_config != 'configurated'
          },
          registroTooltip() {
            /* if (this.future_errors.registro) return this.date_tooltips.no_future_date
            else return this.inAccounting_errors.registro ? this.date_tooltips.no_acc_period : this.date_tooltips.reg_date_before_accounting */
            return this.date_tooltips.reg_date_before_invoice
          },
          errorRetentionType(){
              let missing_fields = {};
              if(this.currentDocument.errorJson){
                  missing_fields = this.currentDocument.errorJson['missing_fields'];
              }
              
              let invoice = {
                  state:this.currentDocument.state,
                  missing_fields : missing_fields,
                  retention_type_name:this.document_retention_type_name,
                  retention_percent:this.currentDocument.metadata?this.currentDocument.metadata['retention_type']:false,
                  retention_amount:this.currentDocument.metadata?this.currentDocument.metadata['retention_amount']:false,

             }
              return showErrorRetentionType(invoice)
          },
          typeCheckRet(){
              let type = 'none'
              if (this.currentCompany.check_ret){
                  type = 'checkbox'
              }
              else if((this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'account_move')){
                  type = 'base'
              }
              else if(this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'invoice'){
                  if(this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas){
                      type = 'detail'
                  }
                  else{
                      type = 'base'
                  }
              }
              return type
          },
          someParamsError(){
              return this.showRequiredDescriptionSII || this.showTypes0Error || this.showRequiredRebu
          },
          showRequiredDescriptionSII(){
              return this.currentDocument.state == 'error_missing_fields' && this.currentDocument.errorJson['missing_fields'].includes('description_sii') && !this.document_description_sii
          },
          showTypes0Error(){
              return this.currentDocument.state == 'error_checking_taxes' && this.currentDocument.errorJson.includes("type_0_incompatibilities") && this.got_feature('feature_type_0_errors') && this.selectedParam
          },
          showRequiredRebu(){
              return this.currentDocument.state == 'error_missing_fields' && this.currentDocument.errorJson['missing_fields'] && this.currentDocument.errorJson['missing_fields'].includes('rebu_precio_compra') && this.document_rebu && this.currentDocument.kind === 'out_invoice' && !this.document_rebu_precio_compra
          },
          hasSomeCustomRet(){
              for(let i in this.tabs){
                      let vats = this.tabs[i].vats
                      for(let j in vats){
                          let vat = vats[j].vat
                          let rb = 'ret_base_'+vat
                          let na = 'not_apl_ret_'+vat
                          let nr = 'not_ret_'+vat
                          if( this.currentDocument.metadata[rb] || this.currentDocument.metadata[rb]==0 || this.currentDocument.metadata[na] || this.currentDocument.metadata[nr]){
                              if(this.currentDocument.metadata[rb] != ''){ //no entenc com considera els no booleans js
                                  return true
                              }
                          }
                      }
              }
              return false
          },
          showCustomRet(){
              return this.hasSomeCustomRet || this.conf_ret_button
          },
          cusRetMarginLeft(){
              return '-4.3%'
          },
          visibleTabs() {
            
            /**
             * Generate a formatted mapping of fiscal locations.
             *
             * An example of the output structure:
             * {
             *   'iva':      ['peninsula'],
             *   'igic':     ['canarias'],
             *   'igic2019': ['canarias_2019'],
             *   'igi':      ['andorra']
             * }
             */
            const fiscalLocationsTabsMap = {};
            this.fiscal_locations.forEach(({ value, impost_types }) => {
                impost_types.forEach(type => {
                    if (!fiscalLocationsTabsMap[type]) {
                        fiscalLocationsTabsMap[type] = [];
                    }
                    fiscalLocationsTabsMap[type].push(value);
                });
            });

            // Define impost metadata for each impost tab.
            //const metadataTabsMap = {
            //    'iva':      this.has_meta_iva,
            //    'igic':     this.has_meta_igic,
            //    'igic2019': this.has_meta_igic2019,
            //    'igi':      this.has_meta_igi,
            //};

            let visibleTabs = null;

            // If the Document's fiscal_location is set and matches a location in the locations tab map,
            // prioritize the impost tab corresponding to that fiscal_location.
            // If not, go the old way.
            if (
                this.got_feature('feature_assign_fiscal_location')
                && this.currentDocument.fiscal_location
                && Object.values(fiscalLocationsTabsMap).some(
                    locations => locations.includes(this.currentDocument.fiscal_location)
                )
            ) {
                visibleTabs = this.tabs.filter(tab => {
                    if (tab.code === 'params') {
                        return this.document_supplierdb_info || this.document_customerdb_info;
                    }
                    if (fiscalLocationsTabsMap[tab.code]) {
                        //return fiscalLocationsTabsMap[tab.code].includes(this.currentDocument.fiscal_location) || metadataTabsMap[tab.code];
                        return fiscalLocationsTabsMap[tab.code].includes(this.currentDocument.fiscal_location);
                    }
                    return [];
                });
            } else {
                visibleTabs = this.tabs.filter(tab => {
                    if (tab.code == 'params') {
                        return this.document_supplierdb_info || this.document_customerdb_info;
                    } else if (tab.code == 'iva' && this.currentCompany && this.currentCompany.tax_type) {
                        return this.currentCompany.tax_type.includes(tab.code) || this.has_meta_iva;
                    } else if (tab.code == 'igic2019'  && this.currentCompany && this.currentCompany.tax_type) {
                        return this.currentCompany.tax_type==tab.code || this.has_meta_igic2019;
                    } else if (tab.code == 'igic'  && this.currentCompany && this.currentCompany.tax_type) {
                        return (this.currentCompany.tax_type.includes(tab.code) && !this.currentCompany.tax_type.includes('igic2019')) || this.has_meta_igic;
                    } else if (tab.code == 'igi'  && this.currentCompany && this.currentCompany.tax_type) {
                        return this.currentCompany.tax_type == tab.code || this.has_meta_igi;
                    }
                    return [];
                });
            }

            /*
            const locationsTabsMap = {
                'peninsula': 'iva',
                'canarias': 'igic',
                'canarias_2019': 'igic2019',
                'andorra': 'igi',
            };
            let tab_selected = visibleTabs.filter(tab => {
                if(locationsTabsMap[this.currentDocument.fiscal_location] === tab.code) {
                    return true;
                }
            });
            if (tab_selected !== undefined && tab_selected.length > 0) {
                alert(tab_selected[0].code)
                this.clickedTab = tab_selected[0];
            }
            */

            return visibleTabs;
          },
          on_fiscal_location_changed() {
            this.fiscal_location_error = ''; // Reset error message

            if (this.currentDocument.fiscal_location) {
                const location_meta_map = {
                    peninsula: this.has_meta_iva,
                    canarias_2019: this.has_meta_igic2019,
                    canarias: this.has_meta_igic,
                    andorra: this.has_meta_igi,
                };
                
                // Check if the selected fiscal location is valid.
                const is_valid_location = Object.entries(location_meta_map).some(
                    ([location, has_meta]) => has_meta && this.currentDocument.fiscal_location === location
                );
                
                if (!is_valid_location) {
                    // Build the error message.
                    this.fiscal_location_error = `Localización Fiscal ${this.currentDocument.fiscal_location.toUpperCase()} Seleccionada. El documento tiene información de: `;
        
                    const impost_meta_list = [
                        { has_meta: this.has_meta_iva, name: 'IVA' },
                        { has_meta: this.has_meta_igic2019, name: 'IGIC 2019' },
                        { has_meta: this.has_meta_igic, name: 'IGIC' },
                        { has_meta: this.has_meta_igi, name: 'IGI' }
                    ];
        
                    // Append applicable error details.
                    this.fiscal_location_error += impost_meta_list
                        .filter(meta => meta.has_meta)
                        .map(meta => meta.name)
                        .join(', ');
                }
            }

            this.setDirty();
          },
          show_third_concept() {
              return !(this.currentDocument.state=='done' && !this.currentDocument.metadata['third_concept']) && this.feature_expens_account_metadata && this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('expens_account_metadata') && (this.document_supplierdb_info || this.document_customerdb_info);
          },
          valid_expens_accounts() {
              let is_valid = false;
              if(this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts){
                  if (this.document_supplierdb_info && this.document_supplierdb_info['expens_accounts']) {
                      is_valid = true;
                      if (!this.document_supplierdb_info['expens_accounts'].length) {
                          is_valid = false;
                      } else {
                          for (let i in this.document_supplierdb_info['expens_accounts']) {
                              if (!this.document_supplierdb_info['expens_accounts'][i].length) {
                                  is_valid = false;
                              }
                          }
                      }
                  }
              }
              else{
                  is_valid = true;
              }
              return is_valid;
          },
          valid_expens_account_bien_inversion() {
              let is_valid = false;
              let companydb_type_params = this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params;
              if(this.currentDocument.bien_inversion && companydb_type_params && companydb_type_params.check_expens_income_accounts && !this.show_third_concept && !('hide' in companydb_type_params && companydb_type_params['hide'].includes('expens_account_bien_inversion'))){
                  if(this.document_supplierdb_info && this.document_supplierdb_info['expens_account_bien_inversion'] && this.document_supplierdb_info['expens_account_bien_inversion'].length) {
                      is_valid = true;
                  }
              }
              else {
                  is_valid = true;
              }
              return is_valid;
          },
          valid_income_accounts() {
              let is_valid = false;
              if(this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts){
                  if (this.document_customerdb_info && this.document_customerdb_info['income_accounts']) {
                      is_valid = true;
                      if (!this.document_customerdb_info['income_accounts'].length) {
                          is_valid = false;
                      } else {
                          for (let i in this.document_customerdb_info['income_accounts']) {
                              if (!this.document_customerdb_info['income_accounts'][i].length) {
                                  is_valid = false;
                              }
                          }
                      }
                  }
              }
              else{
                  is_valid = true
              }
              return is_valid;
          },
          // currentPath() {
          //     let path = false;
          //     if (this.currentDocument.metadata['invoice_date'] && this.currentDocument['paths'].length) {
          //         let date_fields = this.currentDocument.metadata['invoice_date'].split('/');
          //         if (date_fields.length == 3) {
          //             let year = date_fields[2];
          //             for (let i in this.currentDocument['paths']) {
          //                 let path_year = this.currentDocument['paths'][i]['min_date'].split('-')[0];
          //                 if (year == path_year) {
          //                     path = this.currentDocument['paths'][i];
          //                 }
          //             }
          //         }
          //     }
          //     return path;
          // },
          show_retention_type_name() {
              let show = false;
              if (!(this.document_retention_type_name == 'third_value' && ['done','done_manually', 'done_with_warning'].includes(this.currentDocument.state))) {
                  let show_cdb_type = this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('customer_retention_type');
                  if (this.document_kind == 'in_invoice' || (this.feature_customer_retention_type && show_cdb_type)) {
                      show = true;
                  }
              }
              return show;
          },
          filtered_retention_types() {
            return this.get_retention_types.filter(element => {
              const isAgricultureOrLivestock = element.value === 'retention_agriculture_account' || element.value === 'retention_livestock_account';
              const isCapital = element.value === 'retention_capital_account';
              const isTransport = element.value === 'retention_transport_account';
              const isProfessionalStartActivity = element.value === 'retention_professional_start_act_account';                

              if ((!this.currentCompany.iva_agrario_pesca || !this.feature_retention_accounts_agrario) && isAgricultureOrLivestock) {
                return false;
              }
              if (!this.got_feature('feature_capital_retention') && isCapital) {
                return false;
              }
              if (!this.got_feature('feature_retention_professional_start_activity') && isProfessionalStartActivity) {
                return false;
              }
              if (isTransport && (this.document_kind == 'out_invoice' || !this.got_feature('feature_retention_accounts_transport'))) {
                return false;
              }
              return true;
            });
          },
          taxTypesDoNotMatch() {
              const valueIsFalsyOrZeroString = v => {
                  if (!v) return true

                  if (typeof v === 'string') {
                      const parsedValue = parseFloat(v)
                      if (!parsedValue && !_.isNaN(parsedValue)) return true
                  }

                  return false
              }

              // If has feature_reviso_allow_no_bases and total_amount is 0, don't mark error
              if (this.got_feature('feature_reviso_allow_no_bases') && this.currentDocument.metadata && this.currentDocument.metadata.total_amount == 0) {
                  return false
              }

              const taxRegex = new RegExp('[^_\W]+')
              const vatBases = this.vat.map(e => `base_${e.vat}`)
              const igicBases = this.igic.map(e => `base_${e.vat}`)
              const metadataNoFalsies = _.pickBy(this.currentDocument.metadata, v => !valueIsFalsyOrZeroString(v))
              const taxType = this.selectedParamOption ? this.selectedParamOption.match(taxRegex)[0] : ''

              if (this.selectedParam !== 'intracomunitario') return false

              if (taxType === 'vat') {
                  return _.intersection(vatBases, Object.keys(metadataNoFalsies)).length === 0
              } else if (taxType === 'igic') {
                  return _.intersection(igicBases, Object.keys(metadataNoFalsies)).length === 0
              }
              return true
          },
          apply_modelo_label() {
              let label = 'Aplica 34';
              if (this.selectedParam == 'intracomunitario') {
                  label = label + '9';
              } else {
                  label = label + '7';
              }
              return label;
          },
          readOnlyThirdConcept(){
             return this.currentCompany.companydb_type.value == 'aplifisa_fiscal' && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.hasOwnProperty('hide') && this.currentCompany.companydb_type.params.hide.includes('expens_account_bien_inversion') && this.currentDocument.bien_inversion && this.valid_expens_account_bien_inversion
          },
        //   borrarrrrrrrrrrrrrrrrrrrrrrrrr!!!!!!!!!!!!!!!!!!!!!!!!!
          automaticPaymentAccountLabel() {
              let value = null

              if (this.automaticPaymentAccount) {
                  value = this.labelArray.filter(e => e.value === this.automaticPaymentAccount)[0]
                  value = value.text
              }

              return value
          },
          automaticChargeAccountLabel() {
              let value = null

              if (this.automaticChargeAccount) {
                  const filtered = this.labelArray.filter(e => e.value === this.automaticChargeAccount)
                  value = filtered[0]

                  if (value && value.text) {
                      value = value.text
                  } else {
                      console.warn('Value text not found: ', this.automaticChargeAccount)
                      value = null
                  }
              }

              return value
          },
          noDeducibleCheckError() {
              return this.currentDocument && ['error_validating_data'].includes(this.currentDocument.state) && this.currentDocument.errorJson.includes('iva_igic_no_deducible');
          },
          isComercianteMinoristaCheckError() {
              return this.currentDocument && ['error_validating_data'].includes(this.currentDocument.state) && this.currentDocument.errorJson.includes('is_comerciante_minorista');
          },
          feature_supplier_comerciante_minorista() {
              let has_perm = false;
              if (this.got_feature('feature_supplier_comerciante_minorista') && this.currentDocument.companydb_info.tax_type == 'igic') {
                  has_perm = true;
              }
              return has_perm;
          },
          is_rectificativa() {
              let is_rect = false;
              if (this.currentDocument.metadata && this.currentDocument.metadata['total_amount']) {
                  if (this.currentDocument.metadata['total_amount'] < 0.0) {
                      is_rect = true;
                  }
              }
              return is_rect;
          },
          url_get_invoices_to_rectify() {
              let url = 'docs_for_rectify/?company_id=' + this.currentCompany.id + '&kind=' + this.document_kind;
              if (this.document_kind == 'in_invoice' && this.supplierdb_info) {
                  url += '&supplier_id=' + this.supplierdb_info.id;
              } else if (this.document_kind == 'out_invoice' && this.customerdb_info) {
                  url += '&customer_id=' + this.customerdb_info.id;
              }
              return url;
          },
          inv_number_to_rectify_error() {
              let error = false;
              if (
                  this.currentDocument.state == 'error_missing_fields' &&
                  this.currentDocument.errorJson['missing_fields'] &&
                  this.currentDocument.errorJson['missing_fields'].length > 0 && 
                  this.currentDocument.errorJson['missing_fields'].includes('inv_number_to_rectify')
              ) {
                  error = true;
              }
              return error;
          }, 
          inv_date_to_rectify_error() {
              let error = false;
              if (
                  (
                      this.currentDocument.state == 'error_missing_fields' &&
                      this.currentDocument.errorJson['missing_fields'] &&
                      this.currentDocument.errorJson['missing_fields'].length > 0 && 
                      this.currentDocument.errorJson['missing_fields'].includes('inv_date_to_rectify')
                  ) || (
                      this.currentDocument.state == 'error_validating_data' &&
                      this.currentDocument.errorJson &&
                      this.currentDocument.errorJson.length > 0 &&
                      this.currentDocument.errorJson.includes('inv_date_to_rectify')
                  )
              ) {
                  error = true;
              }
              return error;
          },
          buzonView(){
            return this.currentCompany && this.currentCompany.companydb_type.value == 'inbox'
          },
          showGenericThirdFields() {
            if (this.document_kind == 'in_invoice' && this.document_supplierdb_info) {
                return this.document_supplierdb_info.is_generic;
            } else if (this.document_kind == 'out_invoice' && this.document_customerdb_info) {
                return this.document_customerdb_info.is_generic;
            }
            return false;
          },
          unmatchingThird() { // return error, tooltip
            let error_data = unmatchingThirdError(this.currentDocument.errorJson)
            return { error : error_data.error, tooltip : error_data.text }
          },
      },
      watch: {
          'currentDocument': {
            handler (newValue, oldValue) {
                if (newValue && this.userData.available_features['feature_see_currency']) {
                    this.currency = this.currentDocument.currency
                }
                if (oldValue == null && newValue != null) this.setDateErrors()
            },
            immediate: true
          },
          selectedParam() {
              setTimeout(() => {
                  this.lastSelectedParam = this.selectedParam;
              })
              if(['no_sujeta','dry_0_percent','inversion_sujeto_pasivo_igic'].includes(this.selectedParam)){
                  let third_params = {}
                  third_params[this.selectedParam] = true
                  this.setType0(third_params)
              }
              else if(['no_sujeta','dry_0_percent','inversion_sujeto_pasivo_igic'].includes(this.lastSelectedParam)){
                  let third_params = {}
                  this.setType0(third_params)
              }
              this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
          },
          selectedParamOption() {
              this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
          },
          selectedParamOption2() {
              this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
          },
          selectedIvaCheck() {
              setTimeout(() => {
                  this.lastSelectedIvaCheck = this.selectedIvaCheck;
              })
          },
          document_supplierdb_info(new_sup, old_sup) {
              if (((new_sup && old_sup) && (new_sup.id!=old_sup.id)) || (new_sup && !old_sup)) {
                  this.updateAutomaticMoveAccounts()
                  this.setType0(this.document_supplierdb_info)
                  this.setIntraDataFromThirdParty(this.document_supplierdb_info);
                  if(this.feature_criterio_de_caja) {
                      this.setCriteriodeCaja(this.document_supplierdb_info);
                  }
                  if (this.feature_supplier_comerciante_minorista) { // Es un computed que usa got_feature
                      this.setIsComercianteMinorista(this.document_supplierdb_info);
                  }
                  this.documentToParam();
                  this.getRetentionTypeFromThird();
                  this.setAutomaticPaymentOrCharge()
              }
              //Si ha cambiado la contrapartida del proveedor
              else if (new_sup && old_sup && new_sup.id==old_sup.id && new_sup.expens_accounts && new_sup.expens_accounts.length > 0 && old_sup.expens_accounts && old_sup.expens_accounts.length > 0 && new_sup.expens_accounts[0] != old_sup.expens_accounts[0]) {
                this.setSupplierAccount();
              }
          },
          document_customerdb_info(new_cus, old_cus) {
              if (((new_cus && old_cus) && (new_cus.id!=old_cus.id)) || (new_cus && !old_cus)) {
                  this.updateAutomaticMoveAccounts()
                  this.setType0(this.document_customerdb_info)
                  this.setIntraDataFromThirdParty(this.document_customerdb_info);
                  this.documentToParam();
                  this.getRetentionTypeFromThird();
                  this.setAutomaticPaymentOrCharge();
              }
              //Si ha cambiado la contrapartida del cliente
              else if (new_cus && old_cus && new_cus.id==old_cus.id && new_cus.income_accounts && new_cus.income_accounts.length > 0 && old_cus.income_accounts && old_cus.income_accounts.length > 0 && new_cus.income_accounts[0] != old_cus.income_accounts[0]) {
                this.setCustomerAccount();
              }
          },
      },
      methods:{
          ...mapActions("cru", ['getAccounts']),
          ...mapActions("cookies", ['initialThirdPartyValuesModal', 'setThirdPartyPosition']),
          ...mapActions("documents", ['updateAutomaticMoveAccounts']),
            getInvoiceLines() {
                return (
                    this.currentDocument &&
                    this.currentDocument.metadata &&
                    this.currentDocument.metadata.invoice_lines
                ) || [];
            },
            formatDate(date) {
                if (!date) return '';

                const dateObj = new Date(date);
                if (isNaN(dateObj.getTime())) return date; 

                const day = String(dateObj.getDate()).padStart(2, '0');
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                const year = dateObj.getFullYear();

                return `${day}/${month}/${year}`;
            },
          toggleSectionVisibility(section) {
              this.$parent.toggleSectionVisibility(section);
          },
          setDateErrors(){
            // date_errors, future_errors
            let dateFuture_errors = invoiceAndFutureDateErrors(
              this.currentDocument.metadata['invoice_date'],
              this.currentDocument.default_accounting_date,
              this.currentDocument.accounting_date_config,
              this.currentDocument.default_registro_date,
              this.currentDocument.registro_date_config,
              new VueFeatureRepository(this.got_feature),
            )
            this.date_errors = dateFuture_errors.date
            this.future_errors = dateFuture_errors.future

            this.inAccounting_errors = inAccountingPeriodErrors(
              this.currentDocument.metadata['invoice_date'],
              this.currentDocument.default_accounting_date,
              this.currentDocument.accounting_date_config,
              this.currentDocument.default_registro_date,
              this.currentDocument.registro_date_config,
              this.currentDocument['paths']
            )
            this.error5years = diff5Years(this.currentDocument.metadata['invoice_date'], this.currentDocument.default_accounting_date, this.currentDocument.accounting_date_config)
          },
          dateErrors_and_setDirty() {
            this.setDateErrors()
            this.setDirty()
          },
          currentPath() {
              let path = false;
              let year = false;
              let date_fields = false;
              if(this.currentDocument.accounting_date_config=='invoice_date'){
                  date_fields = this.currentDocument.metadata['invoice_date'].split('/');
              }
              if(this.currentDocument.accounting_date_config=='today'){
                  let today = new Date();
                  date_fields = [today.getDate(), (today.getMonth() + 1), today.getFullYear()];
              }
              if(this.currentDocument.accounting_date_config=='configurated'){
                  date_fields = this.currentDocument.default_accounting_date.split('/');
              }
              if (date_fields && date_fields.length == 3) {
                  year = date_fields[2];
              }
              if (year && this.currentDocument['paths'].length) {
                  for (let i in this.currentDocument['paths']) {
                      let path_year = this.currentDocument['paths'][i]['min_date'].split('-')[0];
                      if (year == path_year) {
                          path = this.currentDocument['paths'][i];
                      }
                  }
              }
              return path;
          },
          get_label(vat){
              if(vat.vat == 'vat_0'){
                  if(!this.got_feature('feature_exenta_no_sujeta')){
                      return '0%'
                  }
                  else if(this.currentDocument.intracomunitario){
                      return '0% Intra'
                  }
                  else if(this.currentDocument.extracomunitario){
                      return '0% Extr.'
                  }
                  else if(this.currentDocument.inversion_sujeto_pasivo_iva){
                      return '0% ISP'
                  }   
              }
              else if(vat.vat == 'igic_0'){
                  if(!this.got_feature('feature_exenta_no_sujeta')){
                      return '0%'
                  }
                  else if(this.currentDocument.intracomunitario){
                      return '0% Intra'
                  }
                  else if(this.currentDocument.extracomunitario){
                      return '0% Extr.'
                  }
                  else if(this.currentDocument.inversion_sujeto_pasivo_igic){
                      return '0% ISP'
                  }   
                  else if (this.currentDocument.is_comerciante_minorista) {
                      return '0% CM'
                  }
              }
              return vat.label
          },
          show_vat(vat){
              if(['vat_10_5','vat_12'].includes(vat) && !this.currentCompany.iva_agrario_pesca){
                  return false
              }
              if(['vat_re_1_75'].includes(vat) && !this.currentCompany.iva_tabaco){
                  return false
              }
              if(['vat_5'].includes(vat) && !this.feature_vat_5){
                  return false
              }
              if(['vat_ns_0','vat_ne_0','igic_ns_0','igic_ne_0'].includes(vat) && !this.got_feature('feature_exenta_no_sujeta')){
                  return false
              }
              if(['vat_re_625'].includes(vat) && !this.got_feature('feature_vat_re_625')){
                  return false
              }
              if (['igic_5'].includes(vat) && !this.got_feature('feature_igic_5')) {
                  return false
              }
              return true
          },
          toggleParam() {
              this.setDirty()
              if (this.selectedParam == this.lastSelectedParam) {
                  this.selectedParam = undefined
              } else {
                  // Si se selecciona un parámetro especial, desmarcar REBU
                  const specialParams = ['inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario'];
                  if (specialParams.includes(this.selectedParam) && this.document_rebu) {
                      this.document_rebu = false;
                      this.document_rebu_precio_compra = null;
                  }
              }
          },
          toggleIsRectificativa() {
              for (let i in this.tabs) {
                  if (this.tabs[i].code != "params") {
                      for (let z in this.tabs[i].vats) {
                          if ((("metadata_base_" + this.tabs[i].vats[z].vat) in this) && this['metadata_base_' + this.tabs[i].vats[z].vat]) {
                          //if (("base_" + this.tabs[i].vats[z].vat) in this.currentDocument.metadata) {
                              //this.currentDocument.metadata["base_" + this.tabs[i].vats[z].vat] = this.currentDocument.metadata["base_" + this.tabs[i].vats[z].vat] * (-1);
                              this['metadata_base_' + this.tabs[i].vats[z].vat] = this['metadata_base_' + this.tabs[i].vats[z].vat] * (-1);
                          }
                          if ((("metadata_" + this.tabs[i].vats[z].vat) in this) && this['metadata_' + this.tabs[i].vats[z].vat]) {
                              this['metadata_'+ this.tabs[i].vats[z].vat] = this['metadata_' + this.tabs[i].vats[z].vat] * (-1);
                          }
                      }
                  }                    
              }
              //this.currentDocument.metadata["total_amount"] = this.currentDocument.metadata["total_amount"] * (-1);
              if (('metadata_total_amount' in this) && this['metadata_total_amount']) {
                  this['metadata_total_amount'] =  this['metadata_total_amount'] * (-1);
              }
          },
          resetParamOption() {
              this.selectedParamOption = undefined;
              this.selectedParamOption2 = undefined;
          },
          toggleParamIva() {
              if (this.selectedIvaCheck == this.lastSelectedIvaCheck) {
                  this.selectedIvaCheck = undefined;
              }
              this.document_comerciante_minorista = false;
              this.document_gasto_iva_percent = 50;
          },
          ...mapActions({
              setIntraDataFromThirdParty: "documents/setIntraDataFromThirdParty",
              setCriteriodeCaja: "documents/setCriteriodeCaja",
              setIsComercianteMinorista: "documents/setIsComercianteMinorista",
              setIntraDataFromCustom: "documents/setIntraDataFromCustom",
              setDirty: "documents/setDirty",
              documentToParam: "documents/documentToParam",
              setType0: "documents/setType0",
              fetchDocument: "documents/fetchDocument",
          }),
          show_modal(){
              this.initialThirdPartyValuesModal();
              if(this.document_kind=='in_invoice'){
                  // this.showModalSupplier = true
                  this.$modal.show('modal-supplier');
              }
              else{
                  // this.showModalCustomer = true
                  this.$modal.show('modal-customer');
              }
          },
          setSupplierAccount(){
              if (this.currentDocument.supplierdb_info && this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.type == 'invoice' && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas) {
                  for(let i in this.tabs){
                      let vats = this.tabs[i].vats
                      for(let j in vats){
                          let vat = vats[j].vat
                          if(this['metadata_base_'+vat] || this['metadata_'+vat] || this['metadata_account_'+vat]){
                              this['metadata_account_'+vat] = this.currentDocument.supplierdb_info.expens_accounts[0]
                          }
                      }
                  }
              }
          },
          setCustomerAccount(){
              if (this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.type == 'invoice' && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas) {
                  for(let i in this.tabs){
                      let vats = this.tabs[i].vats
                      for(let j in vats){
                          let vat = vats[j].vat
                          if(this['metadata_base_'+vat] || this['metadata_'+vat] || this['metadata_account_'+vat]){
                              this['metadata_account_'+vat] = this.currentDocument.customerdb_info.income_accounts[0]
                          }
                      }
                  }
              }
          },
          on_supplierdb_changed() {
              this.setType0(this.document_supplierdb_info)
              this.setIntraDataFromThirdParty(this.document_supplierdb_info);
              if(this.feature_criterio_de_caja) {
                  this.setCriteriodeCaja(this.document_supplierdb_info);
              }
              if (this.feature_supplier_comerciante_minorista) { // Es un computed que usa got_feature
                  this.setIsComercianteMinorista(this.document_supplierdb_info)
              }

              this.documentToParam()
              this.setDirty();
              this.setSupplierAccount()
              this.getRetentionTypeFromThird();
          },
          on_customerdb_changed() {
              this.setType0(this.document_customerdb_info)
              this.setIntraDataFromThirdParty(this.document_customerdb_info);
              this.documentToParam();
              this.setDirty();
              this.setCustomerAccount();
              this.getRetentionTypeFromThird();
          },
          filterBy(item, queryText, itemText) {
              const text = item.selector_text.toLowerCase();
              const searchText = queryText.toLowerCase();
              return text.indexOf(searchText) > -1;
          },
          get_tipo_cols(){
              if(!this.showCustomRet)
                  return 4
              else{
                  return 3
              }
          },
          get_cuota_cols(){
              if(!this.showCustomRet)
                  return 4
              else{
                  return 3
              }
          },
          canChange() {
              const STATES = [
                  'pending_connect',
                  'done',
                  'done_manually',
                  'accounting_aplifisa_fiscal',
                  'accounting_invoice',
                  'done_with_warning',
                  'pending_sync',
                  'pending_upload',
                  'accounting',
              ];
              return Boolean(!(this.currentDocument && (this.isWaitingFlow || STATES.includes(this.currentDocument.state))) || this.fixMotxo);
          },
          getRetentionTypeFromThird() {
              if (this.document_kind == 'in_invoice') {
                  if (this.document_supplierdb_info && this.document_supplierdb_info['retention_type']) {
                      /*  
                      if (this.document_supplierdb_info['retention_type'] == 'retention_professional_start_act_account') {
                          this.document_retention_type_name = 'retention_professional_account'
                      } else {
                          this.document_retention_type_name = this.document_supplierdb_info['retention_type'];
                      }*/ 
                      this.document_retention_type_name = this.document_supplierdb_info['retention_type'];
                  }
              } else if (this.document_kind == 'out_invoice' && this.feature_customer_retention_type) {
                  if (this.document_customerdb_info && this.document_customerdb_info['retention_type']) {
                      /*
                      if (this.document_customerdb_info['retention_type'] == 'retention_professional_start_act_account') {
                          this.document_retention_type_name = 'retention_professional_account'
                      } else {
                          this.document_retention_type_name = this.document_customerdb_info['retention_type'];
                      } */
                      this.document_retention_type_name = this.document_customerdb_info['retention_type'];
                  }
              }
          },
          getValues(params) {
              this.getAccounts(params).then(() => {});
          },
          resetItems(params) {
              this.accounts = params;
          },
          checkBienInversion() {
              this.setDirty()
              // REBU y Bienes de Inversión son mutuamente excluyentes
              if (this.document_bien_inversion && this.document_rebu) {
                  this.document_rebu = false;
                  this.document_rebu_precio_compra = null;
              }
              if (this.show_third_concept && this.currentDocument.companydb_info.companydb_type.value === 'aplifisa_fiscal'){
                  if (this.document_bien_inversion){
                      this.metadata_third_concept="200";
                  }
                  else if(!this.document_bien_inversion && this.document_supplierdb_info && this.document_supplierdb_info['expens_accounts']){
                      this.metadata_third_concept=this.document_supplierdb_info['expens_accounts'][0]
                  }
              }
          },
          checkRebu() {
              this.setDirty()
              // REBU y Bienes de Inversión son mutuamente excluyentes
              if (this.document_rebu && this.document_bien_inversion) {
                  this.document_bien_inversion = false;
              }
              // REBU y parámetros especiales (ISP IVA, ISP IGIC, Intracomunitario, Extracomunitario) son mutuamente excluyentes
              const specialParams = ['inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario'];
              if (this.document_rebu && specialParams.includes(this.selectedParam)) {
                  this.selectedParam = undefined;
                  this.selectedParamOption = undefined;
                  this.selectedParamOption2 = undefined;
              }
              if (!this.document_rebu) {
                  this.document_rebu_precio_compra = null;
              }
          },
          changeInvNumberToRectify() {
              if (typeof this.invoice_to_rectify == 'object') {
                  this.document_inv_number_to_rectify = this.invoice_to_rectify['inv_number'];
                  if (this.got_feature('feature_invoice_date_to_rectify')) {
                      this.document_inv_date_to_rectify = this.invoice_to_rectify['metadata']['invoice_date'];
                  }
              } else {
                  this.document_inv_number_to_rectify = this.invoice_to_rectify;
              }
          },
          showRectifyFields() {
              return this.rectification_invoice && this.got_feature('feature_invoice_number_to_rectify') && (this.currentDocument.kind=='out_invoice' || (this.currentDocument.kind=='in_invoice' && !this.got_feature('feature_hide_rectify_fields_in_invoice')));
          },
          showDocNumberStr() {
            return this.got_feature('feature_document_number_str') && this.currentCompany.configuration && 'document_doc_number' in this.currentCompany.configuration && this.currentCompany.configuration['document_doc_number'];
          },
          showApplyModelo() {
            return !(Boolean(this.currentDocument.metadata['retention_amount']) || Boolean(this.currentDocument.metadata['retention_type'])) && this.selectedParam != 'extracomunitario' && this.feature_apply_347 && this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('apply_347');
          },
          showApply415() {
            return this.got_feature('feature_apply_415') && this.currentCompany.apply_415;
          },
          confirm(){
            this.show_popup_message = true;
            return new Promise((resolve,reject)=>{
                this.resolvePopupPromise = resolve
            })
          },
          confirmCurrency(res){
            this.show_popup_message = false;
            this.resolvePopupPromise(res)
          },
          loading_update_values(value) {
            this.loading_update_currency = value;
          },
          async update_divisa(){
            try {
                let date = this.currentDocument.metadata['invoice_date']
                await new UpdateMetadataCurrencyCommand(sync_command_dispatcher, this).run(this.currentDocument.currency, date, this.currentDocument.id, this.userData.user)
            } catch (error) {
                console.error('Error update metadata with currency value', error);
            }
            this.currencyHasChanged()
          },
          confirm_restore(){
            this.show_popup_message_restore = true;
            return new Promise((resolve,reject)=>{
                this.resolvePopupPromiseRestore = resolve
            })
          },
          confirmRestoreDetected(res){
            this.show_popup_message_restore = false;
            this.resolvePopupPromiseRestore(res)
          },
          loading_update_restore(value) {
            this.loading_restore_detected = value;
          },
          async restore_detected(){
            try {
                await new RestoreDetectedAmountsCommand(sync_command_dispatcher, this).run(this.currentDocument.id, this.userData.id)
            } catch (error) {
                console.error('Error restore metadata with detected currency', error);
            }
            this.currencyHasChanged()
          },
          currencyHasChanged() {
            this.setDirty();
            this.reintentar();
            this.getCurrencyInfo();
          },
          async getCurrencyInfo() {
            if (this.currentDocument && 'detected_amounts' in this.currentDocument.metadata) {
                try {
                let currency_id = this.currentDocument.metadata["detected_amounts"]["currency_id"]
                await new GetCurrencyInfoQuery(query_dispatcher, this).run(currency_id)
                } catch (error) {
                console.error('Error get currency info', error);
                }
            }
          },
          reintentar() {
            this.$parent.reintentar();
          },
          isImportantField() {
            return true
          },
          showVatRow(metadata, vat) {
            if (!vat) return false
            function isTruthyOrNumber(x) {return x || typeof x === "number"}
            let tax = metadata[vat.vat]
            let base = metadata['base_'+vat.vat]
            let acc = metadata['account_'+vat.vat]
            return isTruthyOrNumber(tax) || isTruthyOrNumber(base) || isTruthyOrNumber(acc)
          },
          onIsCarteraActiveChange(){
            this.setDirty()
            if(!this.document_is_cartera_active){
                this.document_payment_method_id = null
                this.document_cartera = ''
                this.document_cartera_account = ''
            }
          },
          async getPaymentMethods(){
            let args = { companydb_id: this.currentCompany.id }
            this.payment_methods = await this.paymentMethodAPI.getPaymentMethodsByCompanyDB(args)
          },
          getExternalIdOfPaymentMethod(payment_method_id){
            let payment_methods = this.payment_methods.filter(payment_method => payment_method.payment_method_id == payment_method_id)
            let external_id = ''
            if (payment_methods.length > 0){
                external_id = payment_methods[0].external_id
            }
            return external_id
          },
          onPaymentMethodChange(){
            this.setDirty()
            this.document_cartera = this.getExternalIdOfPaymentMethod(this.document_payment_method_id)
          },
          setCarteraData(document_is_cartera_active, document_payment_method_id, document_cartera, document_cartera_account){
            this.document_is_cartera_active = document_is_cartera_active
            this.document_payment_method_id = document_payment_method_id
            this.document_cartera = document_cartera
            this.document_cartera_account = document_cartera_account
          },
          setAutomaticPayment(){
            if (this.document_supplierdb_info && this.document_supplierdb_info.automatic_payment_account){
                switch(this.document_supplierdb_info.automatic_payment_account){
                    case 'y':
                        this.setCarteraData(
                            true, 
                            this.document_supplierdb_info.payment_method_id, 
                            this.document_supplierdb_info.cartera, 
                            this.document_supplierdb_info.payment_account
                        )
                        break
                    case 'm':
                        this.setCarteraData(
                            true, 
                            '', 
                            '', 
                            ''
                        )
                        break
                    case 'n':
                        this.setCarteraData(
                            false, 
                            '', 
                            '', 
                            ''
                        )
                        break
                    case 'na':
                        this.setCarteraData(
                            true, 
                            this.currentCompany.cartera_supplier, 
                            this.getExternalIdOfPaymentMethod(this.currentCompany.cartera_supplier), 
                            this.currentCompany.payment_account
                        )
                        break
                }
            }
          },
          setAutomaticCharge(){
            if (this.document_customerdb_info && this.document_customerdb_info.automatic_charge_account){
                switch(this.document_customerdb_info.automatic_charge_account){
                    case 'y':
                        this.setCarteraData(
                            true, 
                            this.document_customerdb_info.cartera, 
                            this.getExternalIdOfPaymentMethod(this.document_customerdb_info.cartera), 
                            this.document_customerdb_info.charge_account
                        )
                        break
                    case 'm':
                        this.setCarteraData(
                            true, 
                            '', 
                            '', 
                            ''
                        )
                        break
                    case 'n':
                        this.setCarteraData(
                            false, 
                            '', 
                            '', 
                            ''
                        )
                        break
                    case 'na':
                        this.setCarteraData(
                            true, 
                            this.currentCompany.cartera_customer, 
                            this.getExternalIdOfPaymentMethod(this.currentCompany.cartera_customer), 
                            this.currentCompany.charge_account
                        )
                        break
                }
            }
          },
          setAutomaticPaymentOrCharge(){
            if(this.document_kind == 'in_invoice'){
                this.setAutomaticPayment()
                // if(!this.isDisabledPaymentAutomatic()){
                //     this.setAutomaticPayment()
                // }
            }else if(this.document_kind == 'out_invoice'){
                this.setAutomaticCharge()
                // if(!this.isDisabledChargeAutomatic()){
                //     this.setAutomaticCharge()
                // }
            }
          },
          isDisabledPaymentAutomatic(){
            return this.currentCompany && this.currentCompany.automatic_payment_account && this.currentCompany.automatic_payment_account == 'n' || this.document_supplierdb_info && this.document_supplierdb_info.automatic_payment_account && this.document_supplierdb_info.automatic_payment_account == 'n' || !this.canChange()
          },
          isDisabledCarteraSuppliers(){
            return this.isDisabledPaymentAutomatic() || !this.document_is_cartera_active
          },
          isDisabledChargeAutomatic(){
            return this.currentCompany && this.currentCompany.automatic_charge_account && this.currentCompany.automatic_charge_account == 'n' || this.document_customerdb_info && this.document_customerdb_info.automatic_charge_account && this.document_customerdb_info.automatic_charge_account == 'n' || !this.canChange()
          },
          isDisabledCarteraCustomers(){
            return this.isDisabledChargeAutomatic() || !this.document_is_cartera_active
          }
      },
      data(){
          return {
              ACCOUNTING_DATE_OPTIONS,
              REGISTRO_DATE_OPTIONS,
              show_account_detail:false,
              dialog_vat:'',
              PROVIDER_SOMETHING_OPTIONS,
              PROVIDER_SOMETHING_OPTIONS2,
              clickedTab: undefined,
              // selectedParam: undefined,
              // lastSelectedParam: undefined,
              // selectedParamOption: undefined,
              supps: [],
              conf_ret_button:false,
              labelArray: [{'text': 'N/A', 'value': 'na'}, {'text': 'Si', 'value': 'y'}, {'text': 'No', 'value': 'n'}],
              declined_matching:false,
              invoice_to_rectify: '',
              rectification_invoice: undefined,
              available_currencies: [],
              loading_update_currency: false,
              loading_restore_detected: false,
              currency: undefined,
              currency_info: undefined,
              show_popup_message: false,
              show_popup_message_restore: false,
              resolvePopupPromise:undefined,
              resolvePopupPromiseRestore:undefined,
              loading_detected_currency:false,
              pending_states: [
                "text_detected",
                "uploading_bucket",
                "pending",
                "preprocessing",
                "preprocessed",
                "assigned_contract",
                "nif_detected",
                "nif_validated",
                "data_detected",
                "data_formatted",
                "data_validated",
                "move_created",
                "move_loaded",
                "check_duplicated_ok",
                "accounts_assigned",
                "split" ,
                "human_annotated",
                "oriented",
                "move_validated",
                "merging",
                "not_simulated",
                "in_rotation",
                "accounting_payment_move",
                "third_accounts_validated",
                "backtracking",
                "pending_approval",
                "waiting_signature",
                "company_detected",
                "detecting_company",
                "sync_payment_move"
              ],
              show_empty_vats:false,
              fiscal_location_error: '',
              fiscal_locations:[],
              date_tooltips: {
                no_acc_period: "No existe en la empresa ningún ejercicio para esta fecha",
                acc_date_before_invoice: "La Fecha contable debe ser igual o posterior a la Fecha factura",
                // unused: reg_date_before_accounting: "La Fecha registro debe ser igual o posterior a la Fecha contable y a la Fecha factura",
                reg_date_before_invoice: "La Fecha registro debe ser igual o posterior a la Fecha factura",
                acc_inv_5y: "El periodo de la Fecha contable a la de factura debe ser inferior a 5 años",
                no_future_date: "Las fechas factura y contable no pueden ser posteriores a la fecha actual"
              },
              future_errors: {invoice : false, accounting : false, registro : false},
              date_errors: {invoice : false, accounting : false, registro : false},
              inAccounting_errors: {invoice : false, accounting : false, registro : false},
              error5years: null,
              color: { ok : '#ffffff', error : '#ff9898'},
              payment_methods: [],
              paymentMethodAPI: null,
          }
      },
      async mounted() {
          this.paymentMethodAPI = new PaymentMethodAPI()
          await this.getPaymentMethods()
          new GetFiscalLocationInfoQuery(query_dispatcher, this).run();

          if(this.userData.available_features['feature_see_currency']) {
            try {
                await new GetCurrencyCodeListQuery(query_dispatcher, this).run()
            } catch (error) {
                console.error('Error get currency code list', error);
            }
          }
          this.getCurrencyInfo()  
          if (this.selectedParam) {
              this.lastSelectedParam = this.selectedParam;
          }
          if (this.selectedIvaCheck) {
              this.lastSelectedIvaCheck = this.selectedIvaCheck;
          }
          if (!['done','done_manually', 'done_with_warning'].includes(this.currentDocument.state) && this.document_retention_type_name == 'third_value') {
              this.getRetentionTypeFromThird();
          }
          if (this.document_inv_number_to_rectify) {
              this.invoice_to_rectify = this.document_inv_number_to_rectify;
          }
          
          await this.setDateErrors() // init date_errors and inAccounting_errors

      },
      
  }
</script>

<style scoped>

.divider-invoice-tabs {
  background-color: var(--v-primaryLighter-base);
  color:var(--v-primaryDark-base);
  height: 40px;
  padding-left: 12px;
}
.divider-invoice-tabs .divider-img {
  width:24px;
  height:24px;
  align-self:center;
  margin-right:10px;
}  
.divider-invoice-tabs .icon-display-section {
  font-size:15px;
  margin-top:1px;
}
.table-head-invoice {
    border-style:solid;
    border-color:#E5E5E5;
    border-width: thin;
    background-color: #E5E5E5;
    font-size:12px;
    font-weight: 600;
    line-height:30px;
    color:#454545;
}

.table-head-invoice-btn {
  width:19px;
  height:19px;
  align-self: center;
}
.table-head-invoice-btn .v-icon {
  font-size: 16px !important;
  height: 16px !important;
  width: 16px !important;
}
.table-row-invoice {
  border-left-style:solid;
  border-right-style:solid;
  border-bottom-style:solid;
  border-color:#E5E5E5;
  border-width: thin;
}
div.table-iva > div > div {
  border-top-style:solid;
  border-color:#E5E5E5;
  border-width: thin;
}
.table-row-invoice {
  height:21px;
  line-height: 16px;
}
.table-row-invoice >>> div > .row > .col > div > .v-text-field {
  margin-top: 0px;
}
.table-row-invoice >>> div > .v-text-field {
  margin-top: 0px;
}
.table-row-invoice >>> div > .v-text-field input {
    font-size:12px;
    line-height: 16px !important;
}
.table-row-invoice >>> div > .row > .col > div > .v-text-field > .v-input__control > .v-input__slot {
  height: 36px;
}
.table-row-invoice >>> .v-text-field > .v-input__control > .v-input__slot:before {
  border-color:#E5E5E5;
}
.table-row-invoice >>> .v-text-field.v-input--is-disabled .v-input__slot::before {
  border-image: none;
}
.table-row-invoice >>> div > .v-text-field > .v-input__control > .v-input__slot {
  height: 20px;
}   
.table-row-invoice >>> .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 3px 0 2px;
}
.table-row-invoice >>> .v-btn--icon.v-size--default {
  height:20px;
  width: 20px;
}
.table-row-invoice >>> .v-icon {
  font-size:16px;
  height:16px;
  width: 16px;
}

/* Select invoice */
.select-invoice-stylev2 {
  font-size:12px;
  border-radius:2px; 
}
.select-invoice-stylev2 >>> fieldset {
  border-color:#B0B0B0;
}
.select-invoice-stylev2 >>> .v-input__prepend-outer{
  margin-top:2px !important;
  text-wrap:nowrap;
  white-space: nowrap;
}
.select-invoice-stylev2 label {
  color:#454545;
  line-height: 20px;
  font-weight: 600;
  font-family: "Roboto"; 
}
.select-invoice-stylev2 >>> .v-input__slot {
  min-height: 15px !important;
  padding-left:6px !important;
  padding-right:5px !important;
}
.select-invoice-stylev2 >>> input {
  padding: 0px !important;
  line-height:25px;
  font-weight:300;
}
.select-invoice-stylev2 >>> .v-input__append-inner {
  margin-top:1px !important;
  padding-left:2px;
}
.select-invoice-stylev2 >>> .v-input__icon {
  width: 22px;
  height:22px;
  max-width:22px;
  min-width:22px;
}
.select-invoice-stylev2 >>> .v-input__icon .v-icon {
  font-size:18px;
}

.select-invoice-stylev2 >>> .v-select__selection--comma {
  margin:0px;      
}
.select-invoice-stylev2 >>> .v-select__selections {
  padding:0px !important;
  font-weight:300;
}
.select-invoice-stylev2 >>> .v-text-field__details {
  margin-bottom:4px;
}
.select-invoice-stylev2 >>> .v-text-field__details,
.select-invoice-stylev2 >>> .v-messages {
  min-height:0px;
  font-size:10px;
}

.select-invoice-stylev2 >>> .v-text-field.v-text-field--outlined .v-input__control {
  min-height:0px !important;
}
.select-invoice-stylev2.v-text-field--outlined >>> .v-input__control {
  min-height:0px !important;
}
/* Select invoice rounded*/
.select-invoice-stylev2.v-input--is-disabled, 
.select-invoice-stylev2.v-input--is-readonly {
  border-radius: 20px !important;
}

.remove-border-radius.v-input--is-disabled{
  border-radius: 2px !important;
}

/* Buttons edit provider and client  */
.btn-invoice-edit {
  height:25px !important;
  border-color:#DEDEDE;
  border-radius:2px;
  padding:0px !important;
}
.btn-invoice-edit >>> .v-icon{
  font-size:15px;
}

/* Tabs taxs */    
.tabs-taxs-invoice >>> .v-tabs-bar {
  height: 40px;      
  background-color: var(--v-primaryLighter-base);
}
.tabs-taxs-invoice >>> .v-tab {
  font-size:12px;
  font-weight: 600;        
}
.tabs-taxs-invoice >>> .v-tab:not(.v-tab--active) {
  color:var(--v-primaryDark-base) !important;
}
.tabs-taxs-invoice >>> .v-tab:hover::before {
  opacity: 0.22;
}

/* Radio group invoice */
.radio-group-stylev2 {
  margin-top:0px;
}
.radio-group-stylev2 >>> .v-label {
  font-size:12px;
}
.radio-group-stylev2 >>> .v-radio .v-icon {
  font-size:16px;
}
.radio-group-stylev2 >>> .v-radio .v-input--selection-controls__input {
  width:20px;
  height: 20px;
}
.radio-group-stylev2 >>> .v-input--selection-controls__ripple {   
  height: 16px;   
  width: 16px;
  left: -3px;
  top: calc(50% - 15px);   
}
.radio-group-stylev2 >>> .v-radio .v-input--selection-controls__ripple:before {
  left:-2px;
  right:2px;        
}
.radio-group-stylev2 >>> .v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before {  
  -webkit-transform: scale(0.6);
  transform: scale(0.6);  
} 
.radio-group-stylev2 >>> .v-messages {
  min-height: 0px;
} 

/** Checkbox invoice */
.checkbox-stylev2 {
  margin-top:0px;
  padding-top: 4px;
  margin-left:5px;
}
.checkbox-stylev2 >>> .v-input--selection-controls__input {
  width:20px;
  height: 20px;
  padding-top:3px;
}
.checkbox-stylev2 >>> .v-label {        
  font-size:12px;
}
.checkbox-stylev2 >>> .v-icon{
  width:16px;
  height:16px;
  font-size:20px;
}
.checkbox-stylev2 >>> .v-input--selection-controls__ripple {
  width:22px;
  height:22px;
  left:-10px;
  top: calc(50% - 18px);
}
.checkbox-stylev2 >>> .v-messages {
  min-height:0px;
}

.label-text >>> .v-label {
    color:#454545;
    line-height: 20px;
    font-weight: 600;
    font-family: "Roboto";
}

.label-text.v-input--is-disabled >>> .v-label {
    color: #6D6D6D;
}

.divisa {
  display: flex;
  align-items:baseline;
}
.btn-invoice-detail-divisa {
  height:25px !important;
  border-radius:12px;
  border: 1px solid #454545;
  background-color:white !important;
  color:#454545;
  box-shadow:none;
  -webkit-box-shadow:none;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
}
.under__text__divisa {  
  font-size: 12px;
}

.btn-show-empty-vats {
  height: 23px !important;
  border-radius:2px;
  text-transform: none;
  border-color: #B0B0B0;
  font-size:12px;
  font-weight: 500;
  color:#454545;
  letter-spacing:normal;
}
.btn-show-empty-vats .v-icon {
  font-size:16px;
}
.error-background {
  background-color: #ea817a;
}

.disabled >>> .field-invoice-stylev2 .v-input__prepend-outer label {
  color: #6D6D6D !important;
}

</style>

<style scoped>
.bordered-table {
    border: 1px solid #ccc;
}

.bordered-table th,
.bordered-table td {
    border: 1px solid #ccc;
    vertical-align: middle;
}

.bordered-table th {
    font-size: 14px !important;
    font-weight: 600;
    color: #454545;
    text-align: center;
}

.bordered-table td {
    text-align: center;
}

.bordered-table thead {
    border-style: solid;
    border-width: thin;
    background-color: #E5E5E5;
}

.bordered-table td:first-child {
    text-align: left;
    vertical-align: middle;
}

.description-cell {
    max-width: 250px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    vertical-align: middle;
    line-height: 1.5;
}
</style>

<style>
.highlight-important-field .v-input__control {
    border: 2px solid black !important;
}
</style>